<form name="form" #f="ngForm" novalidate>
  <div class="webview" *ngIf="!agreeBox">
    <div class="row col-sm-12 p-0 m-0">
      <h4 class="plan-heading pb-2">Contact Information</h4>
      <div class="row col-sm-12 px-0">
        <div class="col-6 text-left">
          <div class="form-group">
            <input
              type="text"
              autocomplete="doNotAutoComplete"
              class="form-control"
              (input)="onKeyPressfname($event)"
              (change)="onChangeSaveAbondonedOrder($event)"
              [(ngModel)]="first_name"
              placeholder="Legal First Name*"
              name="fName"
              #fName="ngModel"
              (keydown.space)="$event.preventDefault()"
              [ngStyle]="{
                'border-color':
                  (f.submitted || firstnameChange) && fName.invalid ? 'red' : ''
              }"
              required
            />
            <div
              *ngIf="(f.submitted || firstnameChange) && fName.invalid"
              class="alertMsg"
            >
              <div class="posabs" *ngIf="fName.errors.required">
                First Name is required
              </div>
            </div>
            <div [hidden]="fName.pristine || fName !== 'null'" class="">
              <div class="posabs alertMsg">Enter First Name</div>
            </div>
          </div>
        </div>
        <div class="col-6 text-right">
          <div class="form-group">
            <input
              type="text"
              autocomplete="doNotAutoComplete"
              class="form-control"
              (input)="onKeyPresslastname($event)"
              (change)="onChangeSaveAbondonedOrder($event)"
              [(ngModel)]="last_name"
              placeholder="Legal Last Name*"
              name="lName"
              #lName="ngModel"
              (keydown.space)="$event.preventDefault()"
              [ngStyle]="{
                'border-color':
                  (f.submitted || lastnameChange) && lName.invalid ? 'red' : ''
              }"
              required
            />
            <div
              *ngIf="(f.submitted || lastnameChange) && lName.invalid"
              class="alertMsg"
            >
              <div class="posabs" *ngIf="lName.errors.required">
                Last Name is required
              </div>
            </div>
            <div [hidden]="lName.pristine || lName !== 'null'" class="">
              <div class="posabs alertMsg">Enter Last Name</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row col-sm-12 px-0">
        <div class="col-6 text-right">
          <div class="form-group text-left" id="primaryaccount">
            <h6 class="" style="font-weight: bold;">Primary Account Holder</h6>
            <ng-select
              [items]="primaryAccountoptions"
              class="customngselectpink"
              placeholder="Primary Account Holder*"
              [searchable]="false"
              [clearable]="false"
              name="selectedoption"
              required
              [(ngModel)]="accountoption"
              #selectedoption="ngModel"
              (change)="changeAccountOption($event)"
            >
            </ng-select>

            <div *ngIf="f.submitted && selectedoption.invalid" class="alertMsg">
              <div class="posabs" *ngIf="selectedoption.errors.required">
                Primary Account Holder is required
              </div>
            </div>
            <div
              [hidden]="selectedoption.pristine || selectedoption.valid"
              class=""
            >
              <div class="posabs alertMsg">Primary Account Holder</div>
            </div>
          </div>
        </div>
        <div class="col-6 text-right">
          <h6 class="" style="font-weight: bold;">&nbsp;</h6>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              id="represnt_mob"
              [(ngModel)]="represnt"
              placeholder="Authorized Representative"
              autocomplete="doNotAutoComplete"
              (input)="representativeValid($event)"
              (change)="onChangeSaveAbondonedOrder($event)"
              name="represnt"
              #represent="ngModel"
              [ngStyle]="{
                'border-color':
                  (f.submitted || clickedOnce) && accountOptionFlag ? 'red' : ''
              }"
            />
          </div>
          <div *ngIf="accountOptionFlag" class="posabs alertMsg">
            {{ accountOptionMessage }}
          </div>
        </div>
      </div>

      <div class="row col-sm-12 px-0">
        <div class="col-6 text-left">
          <div class="form-group" id="phoneeweb">
            <input
              type="text"
              id="phone"
              class="form-control"
              name="phoneNo"
              autocomplete="doNotAutoComplete"
              [(ngModel)]="phone_num1"
              appPhoneNumber
              placeholder="Primary Phone Number*"
              (keypress)="onKeyPress($event)"
              (paste)="onPaste($event)"
              (change)="onChangeSaveAbondonedOrder($event)"
              #phoneNo="ngModel"
              maxlength="12"
              minlength="12"
              (keydown.space)="$event.preventDefault()"
              [ngStyle]="{
                'border-color':
                  (f.submitted || phoneChange) && phoneNo.invalid ? 'red' : ''
              }"
              required
            />
            <div
              *ngIf="(f.submitted || phoneChange) && phoneNo.invalid"
              class="alertMsg"
            >
              <div class="posabs" *ngIf="phoneNo.errors.required">
                Phonenumber is required
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 text-right">
          <div class="form-group text-left pink-ng-select" id="langaaid">
            <ng-select
              [items]="languages"
              class="customngselectpink"
              placeholder="Language Preference"
              [searchable]="false"
              [clearable]="false"
              name="selectedLang"
              required
              [(ngModel)]="language"
              (change)="onChangeSaveAbondonedOrder($event)"
              #selectedLang="ngModel"
            >
            </ng-select>
            <div *ngIf="f.submitted && selectedLang.invalid" class="alertMsg">
              <div class="posabs" *ngIf="selectedLang.errors.required">
                Language is required
              </div>
            </div>
            <div
              [hidden]="selectedLang.pristine || selectedLang.valid"
              class=""
            >
              <div class="posabs alertMsg">Select Language</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row col-sm-12 px-0">
        <div class="col-6 text-left">
          <!-- <div class="form-group float-container boxremove"> -->
          <mat-form-field id="enrollDateField_" style="height: 58px;" class="example-full-width" appearance="fill">
            <mat-label>Date of Birth</mat-label>
            <input
              id="enrollDate"
              name="dob"
              matInput
              required
              readonly
              [matDatepicker]="picker"
              [max]="maxDate"
              [(ngModel)]="dob"
              (ngModelChange)="valueChanged()"
              (click)="DOB_Click('enrollDate_')"
             
            />
            <mat-datepicker-toggle id="enrollDate_"
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker  #picker></mat-datepicker>
          </mat-form-field>
          <!-- <div class="col-12 p-0">
              <div class="col-6 text-left dobLabel">
                <span class="float-label">Date of Birth*</span>
              </div>
              <div class="col-12 text-right p-0 dateinput" id="defdate">
                <mat-form-field class="example-full-width datePicker" appearance="fill">
                  <mat-label>{{ pickerPlaceholder }}</mat-label>
                  <input
                    matInput
                    required
                    readonly
                    [matDatepickerFilter]="myFilter"
                    [matDatepicker]="picker"
                    [max]="maxDate"
                    formControlName="selectedValue"
                    (ngModelChange)="valueChanged()"
                  />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field> -->
          <!-- <my-date-picker
                  id="enrollDate"
                  name="dOB"
                  type="date"
                  #dOB="ngModel"
                  [defaultMonth]="defaultMonth"
                  [options]="myDatePickerOptions"
                  [(ngModel)]="dob"
                  placeholder="MM/DD/YYYY"
                  class=""
                  style="height: 44px; margin-bottom: 6px"
                  (keydown)="dateOfBirth($event)"
                  required
                ></my-date-picker> -->
          <!-- </div>
            </div> -->
          <div
              *ngIf="(f.submitted || clickedOnce) && dobinvalid"
              class="alertMsg"
            >
              <div class="posabs" >Date of Birth is required</div>
            </div>
           
          <p class="dobMsg mt-1">
            This is to confirm you are at least 18yrs of age or older and are
            eligible to establish energy utility service in your name.
          </p>
          <!-- </div> -->
        </div>
        <div class="col-6 text-left">
          <div class="form-group" id="emaileweb">
            <input
              type="text"
              autocomplete="doNotAutoComplete"
              class="form-control"
              [(ngModel)]="email_address"
              (input)="onKeyPressEmail($event)"
              name="email"
              #email="ngModel"
              [ngClass]="{ 'is-invalid': f.submitted && email.invalid }"
              (keydown.space)="$event.preventDefault()"
              (change)="onChangeSaveAbondonedOrder($event); Emailvalidate($event)"
              [ngStyle]="{
                'border-color':
                  (f.submitted || emailChange) && email.invalid ? 'red' : ''
              }"
              required
              style="height: 42px"
              placeholder="Email Address*"
              email
              pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)\.*$"
            />
            <div
              *ngIf="(f.submitted || emailChange) && email.invalid"
              class="alertMsg"
            >
              <div class="posabs" *ngIf="email.errors.required">
                Email is required
              </div>
            </div>
            <p class="emailAlign mt-1" *ngIf="displayInvoiceValueBoth()">
              <strong>Note:</strong> Your email will be used in accodance with
              '{{ selectedProduct.energy_provider }}' Privacy Policy and you
              will receive more information about our policy with our welcome
              letter.
            </p>
            <div
              [hidden]="email.valid || email.pristine || !email.errors.pattern"
              class=""
            >
              <div class="posabs alertMsg">Please enter a valid email</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mobileview mt-4">
    <div class="d-flex h-100 col-sm-12 px-0 m-0 flex-wrap">
      <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
        <img style="width: 100%" src="assets/images/signimg.jpg" />
      </div>
      <div class="col-sm-9 col-9 pr-0 my-auto">
        <div class="arrow_box">
          <h1 class="questionMob text-left">
            What is your contact information?
          </h1>
        </div>
      </div>
      <div class="col-sm-9 col-9 float-right m-auto text-center mt-4 px-0 pt-3">
        <div class="col-12 p-0 position-relative">
          <div class="float-label-control">
            <label for="fname">Legal First Name*</label>
            <input
              class="form-control inputshadow"
              id="fName"
              name="fname"
              type="text"
              [(ngModel)]="first_name"
              placeholder="Legal First Name*"
              name="fName"
              #fName="ngModel"
              (keydown.space)="$event.preventDefault()"
              required
            />
          </div>
          <div class="invalid-feedback posabs">
            <div class="alertMsg">
              <div
                class=""
                *ngIf="f.submitted && fName.invalid && fName.errors.required"
              >
                First Name is required
              </div>
            </div>
            <div [hidden]="fName.valid || fName.pristine" class="">
              <div class="alertMsg">Enter First Name</div>
            </div>
          </div>
        </div>
        <div class="col-12 p-0 position-relative">
          <div class="float-label-control">
            <label for="lname">Legal Last Name*</label>
            <input
              type="text"
              name="lname"
              id="lName"
              class="form-control inputshadow"
              [(ngModel)]="last_name"
              placeholder="Legal Last Name*"
              name="lName"
              #lName="ngModel"
              (keydown.space)="$event.preventDefault()"
              required
            />
          </div>
          <div class="invalid-feedback posabs">
            <div class="alertMsg">
              <div
                class=""
                *ngIf="f.submitted && lName.invalid && lName.errors.required"
              >
                Last Name is required
              </div>
            </div>
            <div [hidden]="lName.valid || lName.pristine" class="">
              <div class="alertMsg">Enter Last Name</div>
            </div>
          </div>
        </div>
        <div class="col-12 p-0 position-relative">
          <div class="float-label-control">
            <label for="email">Email Address*</label>
            <input
              type="text"
              class="form-control inputshadow"
              id="email_mob"
              [(ngModel)]="email_address"
              (change)="confirmbtn1($event, f.form.valid)"
              placeholder="Email Address*"
              name="email"
              #email="ngModel"
              (change)="confirmbtn1($event, f.form.valid)"
              [ngClass]="{ 'is-invalid': f.submitted && email.invalid }"
              (keydown.space)="$event.preventDefault()"
              required
              email
              pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)\.*$"
            />
          </div>
          <div class="invalid-feedback posabs">
            <div class="alertMsg">
              <div
                class=""
                *ngIf="f.submitted && email.invalid && email.errors.required"
              >
                Email is required
              </div>
            </div>

            <div
              [hidden]="email.valid || email.pristine || !email.errors.pattern"
              class=""
            >
              <div class="alertMsg">Please enter a valid email</div>
            </div>
          </div>
          <div>
            <p class="emailAlign mt-1" *ngIf="displayInvoiceValueBoth()">
              <strong>Note:</strong> Your email will be used in accodance with
              '{{ selectedProduct.energy_provider }}' Privacy Policy and you
              will receive more information about our policy with our welcome
              letter.
            </p>
          </div>
        </div>

        <div class="mb-4 container langmagrntp text-center p-0">
          <label
            id="accountHolder"
            class="font-weight-normal-calibre font15 lnhgt"
            >Primary Account Holder?*</label
          >
          <div class="m-auto d-flex">
            <div class="col-6 pr-1">
              <a
                class="form-control boxshadnone font-weight-normal-calibre font15 lnhgt"
                id="yesId"
                (click)="selectaccountMbl('Yes', 'yesId')"
                >Yes</a
              >
            </div>
            <div class="col-6 pl-1">
              <a
                class="form-control boxshadnone alignlanguage font-weight-normal-calibre font15 lnhgt"
                id="noId"
                (click)="selectaccountMbl('No', 'noId')"
                >No</a
              >
            </div>
          </div>
        </div>
        <div class="float-label-control">
          <label for="rep" style="color: #2b2e34 !important"
            >Authorized Representative</label
          >
          <input
            type="text"
            name="rep"
            class="form-control inputshadow"
            name="represnt"
            [(ngModel)]="represnt"
            #represent="ngModel"
            placeholder="Authorized Representative (Optional)"
          />
        </div>

        <div class="col-12 p-0 position-relative">
          <div class="float-label-control" style="margin-bottom:0px !important">
            <label for="phoneNo">Primary Phone Number*</label>
            <input
              type="tel"
              class="form-control inputshadow"
              id="phone_mob"
              name="phoneNo"
              autocomplete="off"
              [(ngModel)]="phone_num1"
              placeholder="Primary Phone Number*"
              #appPhoneNumber
              (input)="onKeyPressMobile($event)"
              (paste)="onPaste($event)"
              #phoneNo="ngModel"
              maxlength="12"
              minlength="12"
              (keydown.space)="$event.preventDefault()"
              (blur)="phoneValidation()"
              required
            />
          </div>
          <span *ngIf="MobilephoneNoError" style="font-size: 80% !important;color: #dc3545 !important;" >Phone number is invalid. Correct format is XXX-XXX-XXXX</span>
        </div>
        <div class="col-12 p-0 position-relative">
          <div class="float-label-control">
            <label for="phnum" style="font-size: 15px !important"
              >Enroll in SMS Notifications?</label
            >
          </div>
          <div class="row col-sm-12">
            <div class="form-group" id="order">
              <div class="row checkbox-ptpb-0 gray-checkbox">
                <div
                  class="col-md-10 custom-control custom-checkbox chkboxtop chkbox ml-2 mt-0 pt-0"
                  style="margin-bottom: 3px !important"
                >
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="enablesmshonest"
                      style="padding-bottom: 0 !important"
                      name="example1"
                      [(checked)]="enablesmshonest"
                      (change)="
                        checkboxEvntenableSMS($event, 'enablesmshonest')
                      "
                    />
                    <label
                      class="custom-control-label text-left align-top mb-0"
                      for="enablesmshonest"
                      style="
                        line-height: 16px !important;
                        font-size: 15px !important;
                        padding-left: 0px !important;
                        vertical-align: text-top;
                        margin-top: 11px;
                      "
                    >
                      Yes, Honest Gorilla</label
                    ><i
                      class="fa fa-question-circle mt-2 ml-1"
                      style="
                        vertical-align: bottom !important;
                        cursor: pointer !important;
                      "
                      aria-hidden="true"
                      (click)="openModalWithClass(template3)"
                    ></i>
                  </div>
                </div>
              </div>

              <div
                class="row checkbox-ptpb-0 gray-checkbox"
                *ngIf="selectedProduct.energy_provider === 'Chariot Energy' || selectedProduct.energy_provider === 'BKV Energy'" 
              >
                <div
                  class="col-md-10 custom-control custom-checkbox chkboxtop chkbox ml-2 mt-0 pt-0"
                  style="margin-bottom: 3px !important"
                >
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="enablesmschariot"
                      style="padding-bottom: 0 !important"
                      name="example1"
                      [(checked)]="enablesmschariot"
                      (change)="
                        checkboxEvntenableSMS($event, 'enablesmschariot')
                      "
                    />
                    <label
                      class="custom-control-label text-left align-top mb-0"
                      for="enablesmschariot"
                      style="
                        line-height: 16px !important;
                        font-size: 15px !important;
                        padding-left: 0px !important;
                        vertical-align: text-top;
                        margin-top: 11px;
                      "
                    >
                      Yes, {{selectedProduct.energy_provider}}</label
                    ><i
                      class="fa fa-question-circle mt-2 ml-1"
                      style="
                        vertical-align: bottom !important;
                        cursor: pointer !important;
                      "
                      aria-hidden="true"
                      (click)="openModalWithClass(template2)"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-4 container langmagrntp text-center p-0">
          <label
            id="languagePreference"
            class="font-weight-normal-calibre font15 lnhgt"
            >Which language do you prefer?*</label
          >
          <div class="m-auto d-flex">
            <div class="col-6 pr-1">
              <a
                class="form-control boxshadnone font-weight-normal-calibre font15 lnhgt"
                id="englishId"
                (click)="selectLangMbl('English', 'englishId')"
                >English</a
              >
            </div>
            <div class="col-6 pl-1">
              <a
                class="form-control boxshadnone alignlanguage font-weight-normal-calibre font15 lnhgt"
                id="spanishId"
                (click)="selectLangMbl('Spanish', 'spanishId')"
                >Spanish</a
              >
            </div>
          </div>
        </div>
        <div class="col-12 p-0 position-relative">
          <!-- <div class="float-label-control"> -->
          <mat-form-field  id="enrollDate_mob_" class="example-full-width" appearance="fill">
            <mat-label>Date of Birth</mat-label>
            <input
              id="enrollDate"
              name="dob"
              matInput
              required
              readonly
              [matDatepicker]="mobpicker"
              [max]="maxDate"
              [(ngModel)]="dob"
              (ngModelChange)="valueChanged()"
              (click)="DOB_Click('enrollDate_mob')"
            />
            <mat-datepicker-toggle id="enrollDate_mob"
              matSuffix
              [for]="mobpicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #mobpicker></mat-datepicker>
          </mat-form-field>
          <!-- <div class="col-12 p-0">
              <div class="col-6 text-left dobLabel">
                <span class="float-label">Date of Birth*</span>
              </div>
              <div class="col-12 text-right p-0 dateinput">
                <my-date-picker
                  name="dOB"
                  type="date"
                  #dOB="ngModel"
                  id="mob_dob"
                  [defaultMonth]="defaultMonth"
                  [options]="myDatePickerOptions"
                  [(ngModel)]="dob"
                  placeholder="MM/DD/YYYY"
                  (keydown)="dateOfBirth($event)"
                  required
                ></my-date-picker>
              </div>
            </div> -->
          <p class="dobMsg mt-1">
            This is to confirm you are at least 18yrs of age or older and are
            eligible to establish energy utility service in your name.
          </p>
          <!-- </div> -->
          <!-- <div class="invalid-feedback posabs">
            <div *ngIf="f.submitted && dob.invalid" class="alertMsg">
              <div class="posabs" *ngIf="dob.errors.required">Select DOB</div>
            </div>
            <div [hidden]="dob.valid || dob.pristine" class="">
              <div class="posabs alertMsg">Select DOB</div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="col-12 px-0 text-center mb-4">
        <a
      
          id="theButton"
          class="btn next mr-1 col-md-5 col-lg-4 mt-2 font18 text-uppercase disabledButton"
          class="btn disabledButton next col-md-5 col-lg-4 mt-2 font18 text-uppercase"
          [ngClass]="{
            isDisabled: validateMobileFields(),
            sectbtn: validateMobileFields()
          }"
          (click)="shownext('showInvoice', validContact)"
          >Next</a
        >
      </div>
    </div>
  </div>
  <!--future invoices mobile view-->
  <div class="mobileview" style="float: left" id="showInvoice">
    <div *ngIf="showInvoice">
      <div class="d-flex h-100 row col-sm-12 p-0 m-0">
        <div
          class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
        >
          <img style="width: 100%" src="assets/images/signimg.jpg" />
        </div>
        <div class="col-sm-9 col-9 px-0 my-auto">
          <div class="arrow_box">
            <h1 class="questionMob text-left">
              {{ invoiceText }}
            </h1>
          </div>
        </div>
      </div>
      <div class="col-sm-9 col-9 ml-auto px-0">
        <div class="col-sm-6 col-md-6 p-0" id="order"></div>
        <div class="m-auto d-flex">
          <div class="col-4 pl-0">
            <a
              class="form-control boxshadnone font-weight-normal-calibre font15 lnhgt"
              style="text-align: center"
              id="paper"
              (click)="getInvoice('Paper')"
              >Paper</a
            >
          </div>
          <div class="col-4 pl-0">
            <a
              class="form-control boxshadnone alignlanguage font-weight-normal-calibre font15 lnhgt"
              style="text-align: center"
              id="paperless"
              (click)="getInvoice('Paperless')"
              >Paperless</a
            >
          </div>
          <div class="col-4 px-0" *ngIf="!displayInvoiceValueBoth()">
            <a
              class="form-control boxshadnone alignlanguage font-weight-normal-calibre font15 lnhgt"
              style="text-align: center"
              id="both"
              (click)="getInvoice('Both')"
              >Both</a
            >
          </div>
        </div>
      </div>
      <div
        class="col-sm-9 col-9 ml-auto px-0"
        *ngIf="
          (selectedProduct.energy_provider === 'Gexa Energy' ||
            selectedProduct.energy_provider === 'Frontier Utilities') &&
            (invoice === 'Paper' || invoice === 'Paperless')
        "
      >
        <div class="row col-sm-12">
          <div class="row checkbox-ptpb-0 gray-checkbox">
            <div
              class="col-md-10 custom-control custom-checkbox chkboxtop chkbox ml-2 mt-0 pt-0"
              style="margin-bottom: 3px !important"
            >
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="goPaperlessGexa"
                  style="padding-bottom: 0 !important"
                  name="example1"
                  [(checked)]="goPaperlessGexa"
                  (change)="checkboxGoPaperless($event, 'goPaperlessGexa')"
                />
                <label
                  class="custom-control-label text-left align-top mb-0"
                  for="goPaperlessGexa"
                  style="
                    line-height: 16px !important;
                    font-size: 15px !important;
                    padding-left: 0px !important;
                    vertical-align: text-top;
                    margin-top: 11px;
                  "
                >
                  Go Paperless! – I agree to receive my bills
                  electronically.</label
                >
                <div class="posabs alertMsg" *ngIf="goPaperlessGexa_error">
                  To sign up for this plan, you must consent to paperless billing
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div style="width: 50% !important; text-align: right">
        <div *ngIf="invoice" class="ash_box mt-4" [@flyOutans]="'in'">
          <h1 class="ansMob">{{ invoice }}</h1>
        </div>
      </div> -->
      <div class="col-12 px-0 col-sm-12 mb-4 text-center" id="ppid">
        <a
          
          [ngClass]="{ isDisabled: !invoice && !goPaperlessGexa, sectbtn: invoice && goPaperlessGexa }"
          
          class="btn disabledButton next col-md-5 col-lg-4 mt-2 font18 text-uppercase"
          (click)="shownext('showSec1', invoice)"
          >Next</a
        >
      </div>
    </div>
  </div>
  <!--sec 1 mobile view-->
  <div class="mobileview" id="showSec1">
    <div *ngIf="showSec1">
      <div class="d-flex h-100 row col-sm-12 p-0 m-0">
        <div
          class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
        >
          <img style="width: 100%" src="assets/images/signimg.jpg" />
        </div>
        <div class="col-sm-9 col-9 px-0 my-auto">
          <div class="arrow_box">
            <h1
            [ngStyle]="{
                'display':
                  (hearusOption  !==  'Friend / Family') ? 'block' : 'none'
              }"
            class="questionMob text-left">How did you hear about us?</h1>

             <div  [ngStyle]="{
                        'display':
                          (hearusOption  ==  'Friend / Family') ? 'block' : 'none'
                      }"  >
                
                <h1 class="questionMob text-left">You were referred by {{displayPromoName(promo_code)}}</h1>
                <h6 style="color: white; margin-left: 10px;"> Thanks for signing up with Honest Gorilla.</h6>

              </div>
          </div>
        </div>
      </div>
      <div class="col-sm-9 col-9 ml-auto px-0">
        <div class="col-sm-6 col-md-6 form-group p-0" id="order">
          <ng-select  
            [ngStyle]="{
                'display':
                  (hearusOption  !==  'Friend / Family') ? 'block' : 'none'
              }"

           [disabled]="disabledhowdid"
            name="hearusOption"
            [items]="referrals"
            placeholder="Select"
            [searchable]="true"
            [clearable]="false"
            (change)="getReferrals(hearusOption)"
            [(ngModel)]="hearusOption"
            id="referral_select"
            (open)="focusInputField()"
            (close)="close()"
          ></ng-select>
        </div>
        <div class="col-sm-6 col-md-6 p-0" [ngStyle]="{
                'display':
                  (hearusOption  !==  'Friend / Family') ? 'block' : 'none'
              }">
          <div class="form-group">
            <input
            [disabled]="disabledpromo"
            [readonly]="disabledpromo"
              type="text"
              class="form-control"
              name="promoCode"
              (input)="getpromo($event)"
              [(ngModel)]="promo_code"
              #promoCode="ngModel"
              placeholder="Promo Code"
            />
            <p class="ml-1 font-weight-normal-calibre promofnt mt-3">
              If you have a promo code or someone referred you, please let us
              know
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 px-0 col-sm-12 mb-4 text-center" *ngIf="howdidButton">
        <a
          
          [ngClass]="{ isDisabled: !hearusOption, sectbtn: hearusOption }"
          
          class="btn disabledButton next col-md-5 col-lg-4 mt-2 font18 text-uppercase"
          (click)="shownext('showSec2', hearusOption)"
          >Next</a
        >
      </div>
    </div>
  </div>
  <!--future invoices webview-->

  <div class="row col-sm-12 p-0 m-0 sec3 webview" *ngIf="!agreeBox">
    <h4 class="plan-heading">Enroll in SMS Notifications?</h4>
    <div class="row col-sm-12 p-0">
      <div class="col-sm-6 col-md-6 form-group" id="order">
        <div class="row checkbox-ptpb-0 gray-checkbox">
          <div
            class="col-md-10 custom-control custom-checkbox chkboxtop chkbox ml-2 mt-0 pt-0"
            style="margin-bottom: 3px !important"
          >
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                id="enablesmshonest"
                style="padding-bottom: 0 !important"
                name="example1"
                [(checked)]="enablesmshonest"
                (change)="checkboxEvntenableSMS($event, 'enablesmshonest')"
              />
              <label
                class="custom-control-label text-left align-top mb-0"
                for="enablesmshonest"
                style="
                  line-height: 16px !important;
                  font-size: 15px !important;
                  padding-left: 0px !important;
                  vertical-align: text-top;
                  margin-top: 12px;
                "
              >
                Yes, Honest Gorilla</label
              ><i
                class="fa fa-question-circle mt-2 ml-1"
                style="
                  vertical-align: bottom !important;
                  cursor: pointer !important;
                "
                aria-hidden="true"
                (click)="openModalWithClass(template3)"
              ></i>
            </div>
          </div>
        </div>

        <div
          class="row checkbox-ptpb-0 gray-checkbox"
          *ngIf="selectedProduct.energy_provider === 'Chariot Energy' || selectedProduct.energy_provider === 'BKV Energy'"
        >
          <div
            class="col-md-10 custom-control custom-checkbox chkboxtop chkbox ml-2 mt-0 pt-0"
            style="margin-bottom: 3px !important"
          >
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                id="enablesmschariot"
                style="padding-bottom: 0 !important"
                name="example1"
                [(checked)]="enablesmschariot"
                (change)="checkboxEvntenableSMS($event, 'enablesmschariot')"
              />
              <label
                class="custom-control-label text-left align-top mb-0"
                for="enablesmschariot"
                style="
                  line-height: 16px !important;
                  font-size: 15px !important;
                  padding-left: 0px !important;
                  vertical-align: text-top;
                  margin-top: 12px;
                "
              >
                Yes, {{selectedProduct.energy_provider}}</label
              ><i
                class="fa fa-question-circle mt-2 ml-1"
                style="
                  vertical-align: bottom !important;
                  cursor: pointer !important;
                "
                aria-hidden="true"
                (click)="openModalWithClass(template2)"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row col-sm-12 p-0 m-0 sec3 webview" *ngIf="!agreeBox">
    <h4 class="plan-heading">{{ invoiceText }}</h4>
    <div class="row col-sm-12 p-0">
      <div class="col-sm-6 col-md-6 form-group" id="fetyureInvoice">
        <ng-select
          [items]="invoices"
          class="customngselectpink"
          placeholder="Select*"
          id="invoiceee"
          [searchable]="false"
          [clearable]="false"
          (change)="getInvoice(invoice)"
          name="invoiceW"
          [(ngModel)]="invoice"
          #invoiceW="ngModel"
        >
        </ng-select>
        <div
        *ngIf="(f.submitted || clickedOnce) && invoiceInvalid"
        class="alertMsg"
      >
        <div class="posabs" >Invoice is required</div>
      </div>
      </div>
    
    </div>
    <div
      class="row checkbox-ptpb-0 gray-checkbox"
      *ngIf="
        (selectedProduct.energy_provider === 'Gexa Energy' ||
          selectedProduct.energy_provider === 'Frontier Utilities') &&
        (invoice === 'Paper' || invoice === 'Paperless')
      "
      style="width: 500px"
    >
      <div
        class="col-md-10 custom-control custom-checkbox chkboxtop chkbox ml-2 mt-0 pt-0"
        style="margin-bottom: 3px !important"
      >
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            id="goPaperlessGexa_"
            style="padding-bottom: 0 !important"
            name="example1"
            [(checked)]="goPaperlessGexa"
            (change)="checkboxGoPaperless($event, 'goPaperlessGexa')"
          />
          <label
            class="custom-control-label text-left align-top mb-0"
            for="goPaperlessGexa_"
            style="
              line-height: 16px !important;
              font-size: 15px !important;
              padding-left: 0px !important;
              vertical-align: text-top;
              margin-top: 12px;
            "
          >
            Go Paperless! – I agree to receive my bills electronically.</label
          >
          <div class="alertMsg  posabs" *ngIf="goPaperlessGexa_error">
            To sign up for this plan, you must consent to paperless billing
          </div>
        </div>
      </div>
    </div>
  </div>
  <br />
  <!--sec 1 web view-->
  <div class="row col-sm-12 p-0 m-0 sec3 webview" *ngIf="!agreeBox">
    <h4  [ngStyle]="{
                'display':
                  (hearusOption  !==  'Friend / Family') ? 'block' : 'none'
              }"class="plan-heading">How did you hear about us?</h4>

    <div   [ngStyle]="{
                'display':
                  (hearusOption  ==  'Friend / Family') ? 'block' : 'none'
              }"  >
        
        <h4 class="plan-heading">You were referred by {{displayPromoName(promo_code)}}</h4>
        Thanks for signing up with Honest Gorilla.
      </div>
    
    <div class="row col-sm-12 p-0">
      <div class="col-sm-6 col-md-6 form-group" id="referalcd">
        <ng-select

        [ngStyle]="{
                'display':
                  (hearusOption  !==  'Friend / Family') ? 'block' : 'none'
              }"

         [disabled]="disabledhowdid"
          [items]="referrals"
          id="referald"
          placeholder="Select*"
          [searchable]="false"
          [clearable]="false"
          (change)="getReferrals(hearusOption)"
          name="hearusOptions"
          [(ngModel)]="hearusOption"
          #hearusOptions="ngModel"
        ></ng-select>
        <div
        *ngIf="(f.submitted || clickedOnce) && howdidInvalid"
        class="alertMsg"
      >
        <div class="posabs" >How did you hear about us is required</div>
      </div>
      </div>
      <div class="col-sm-6 col-md-6"  [ngStyle]="{
                'display':
                  (hearusOption  !==  'Friend / Family') ? 'block' : 'none'
              }"  >
        <div class="form-group">
          <input
           [disabled]="disabledpromo"
            type="text"
            class="form-control"
            name="promoCode"
            (input)="getpromo($event)"
            [(ngModel)]="promo_code"
            #promoCode="ngModel"
            placeholder="Promo Code"
          />
          <small class="ml-1"
            >Someone refer you? Let us know so we can credit them!</small
          >
        </div>
      </div>
    </div>
  </div>
  <!-- Sec 2 Mobile view -->
  <div class="mobileview" id="showSec2">
    <div *ngIf="showSec2">
      <div class="d-flex h-100 row col-sm-12 p-0 m-0">
        <div
          class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
        >
          <img style="width: 100%" src="assets/images/signimg.jpg" />
        </div>
        <div class="col-sm-9 col-9 px-0 my-auto">
          <div class="arrow_box">
            <h1 class="questionMob text-left">
              This information we’ll keep private.
            </h1>
          </div>
        </div>
      </div>
      <div class="col-sm-9 col-9 ml-auto px-0">
        <p class="font15 font-weight-normal-calibre lnhegt16">
          {{ selectedProduct.energy_provider }} requires a credit check to be
          performed on all customers to determine if a deposit is required. This
          is a ‘soft’ check, over an encrypted connection. Your credit score
          will not be impacted.
        </p>
        <div class="row col-sm-12 p-0 m-0">
          <div class="col-10 col-sm-5 col-md-5 px-0">
            <div class="form-group mb-1">
              <input
                type="tel"
                class="form-control"
                id="disssn"
                [(ngModel)]="ssn"
                autocomplete="off"
                placeholder="{{SSN_Placeholder}}"
                name="ssn"
                #ssn1="ngModel"
                (blur)="showMask = true;  validateSSNLength($event)"
                (change)="privateInfoChanged($event, f.form.valid)"
                (keyup)="ssnValidate($event)"
                maxlength="11"
                required
                [ngStyle]="{
                  'border-color': !ssnInvalid ? 'red' : ''
                }"
              />
         
              <div
                [hidden]="ssn1.valid || ssn1.pristine || !ssn1.errors.pattern"
                class=""
              ></div>
              <div
                class="ml-1 pt-2"
                style="font-size: 12px; line-height: 1.1 !important"
              >
                The accuracy of a {{SSN_helpText}} may help you avoid a deposit
              </div>
            </div>
          </div>
          <div class="float-right mob-px-5" style="width: 10%" *ngIf="ssn">
            <i
              *ngIf="user_bot"
              (click)="toggleShowPassword(newVal)"
              id="toggleId"
              class="fa fa-eye"
              style="cursor: pointer"
            ></i>
            <i
              *ngIf="!user_bot"
              (click)="toggleShowPassword1(ssn123)"
              id="toggleId"
              class="fa fa-eye-slash"
              style="cursor: pointer"
            ></i>
          </div>
          <div
            class="col-sm-6 col-md-6 px-0"
            *ngIf="selectedProduct.energy_provider !== '4Change Energy'"
          >
            <div class="col-sm-1 col-md-1 px-0 text-center">
              <p>and/or</p>
            </div>
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                [(ngModel)]="license"
                autocomplete="off"
                placeholder="Driver's License Number"
                name="license"
                maxlength="12"
                #license1="ngModel"
                [disabled]="energy_provider === 'Texans Energy'"
                (change)="privateInfoChanged($event, f.form.valid)"
              />
            </div>
            <div class="form-group">
              <div class="col-12 pr-0 pull-right pl-0" id="order">
                <ng-select
                  [items]="statesArr"
                  placeholder="Select"
                  [searchable]="true"
                  [clearable]="false"
                  name="selectedstate"
                  [(ngModel)]="state"
                  (change)="getState(state)"
                >
                </ng-select>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="displayInvoiceValueBoth()">
            <!-- <div class="d-flex h-100 row col-sm-12 p-0 m-0"> -->
            <div
              class="custom-control custom-checkbox chkbox mb-0"
              style="
                margin-bottom: 0px !important;
                margin-top: 0 !important;
                border: none;
              "
            >
              <input
                type="checkbox"
                id="phoneCheck"
                class="custom-control-input"
              />
              <label
                class="custom-control-label font16 ml-2"
                style="
                  cursor: pointer !important;
                  line-height: 100%;
                  font-size: 16px !important;
                  font-weight: normal;
                  color: black !important;
                "
                for="phoneCheck"
                >I agree to be contacted by or on behalf of {{ selectedProduct.energy_provider }} at the telephone number(s) provided about product and service offers, including via autodialed calls and text messages, and calls that use an artificial or prerecorded voice. I understand that I do not need to give this consent in order to purchase goods or services from {{ selectedProduct.energy_provider }}.</label
              >
            </div>
            <!-- </div> -->
          </div>
        </div>
      </div>
    
      <div class="row" id="div1234">
        <div class="col-12 px-0 text-center mt-3">
          <button
            class="btn mr-2 ml-2 next mt-2 font18 text-uppercase disabledButton"
            [disabled]="!ngClass"
           
           
            [ngClass]="{ sectbtn: ngClass, pt4: !ngClass }"
            (click)="showAcceptances(f.form.valid)"
          >
            Next
          </button>
        </div>
      </div>
  
      <br />
      <br />
    </div>
  </div>
  <!--Sec 2 web view-->
  <div class="row col-sm-12 p-0 m-0 sec3 webview" *ngIf="!agreeBox">
    <h4 class="plan-heading">This information we’ll keep private.</h4>
    <p class="lnhegt16 mb-3">
      {{ selectedProduct.energy_provider }} requires a credit check to be
      performed on all customers to determine if a deposit is required. This is
      a ‘soft’ check, over an encrypted connection. Your credit score will not
      be impacted.
    </p>
    <div class="row pl-3 w-100">
      <div class="col-sm-6 col-md-6 pl-0">
        <div class="form-group">
          <input
            class="form-control"
            [(ngModel)]="ssn"
            autocomplete="off"
            id="disssn"
            placeholder="{{SSN_Placeholder}}"
            name="ssn"
            #ssn1="ngModel"
            (blur)="showMask = true; validateSSNLength($event); validatemsg($event)"
            (change)="privateInfoChanged($event, f.form.valid)"
            (keyup)="ssnValidate($event)"
            maxlength="11"
            minlength="11"
            required
            [ngStyle]="{
              'border-color': !ssnInvalid ? 'red' : ''
            }"
          />
          <div
          *ngIf="ssnmsg || ((f.submitted || clickedOnce) && ssnInvalidmsg)"
          class="alertMsg"
        >
          <div class="posabs" > {{SSNValidationMsg}}</div>
        </div>
      
          <div
            class="ml-1 pt-2"
            *ngIf="ssnvalidation"
            style="color: #ed1976; font-size: 14px; line-height: 1.1 !important"
          >
            Please enter 9 digit ssn
          </div>
          <div
            class="ml-1 pt-2"
            style="font-size: 12px; line-height: 1.1 !important"
          >
            The accuracy of a {{SSN_helpText}} may help you avoid a deposit
          </div>

          <input type="hidden" value="{{ ssn }}" [(ngModel)]="ssn" name="ssn" />
        </div>
      </div>
      <div class="col-md-1 px-0 text-left mt-1">
        <div *ngIf="ssn">
          <i
            *ngIf="user_bot"
            (click)="toggleShowPassword(newVal)"
            id="toggleId"
            class="fa fa-eye mr-3"
            style="cursor: pointer"
          ></i>
          <i
            *ngIf="!user_bot"
            (click)="toggleShowPassword1(ssn123)"
            id="toggleId"
            class="fa fa-eye-slash mr-3"
            style="cursor: pointer"
          ></i>
        </div>
      </div>
      <div
        class="col-sm-6 col-md-5"
        *ngIf="selectedProduct.energy_provider !== '4Change Energy'"
      >
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="license"
            autocomplete="off"
            placeholder="Driver's License Number"
            [disabled]="disableBtnm"
            name="license"
            #license1="ngModel"
            maxlength="12"
            (change)="privateInfoChanged($event, f.form.valid)"
          />
        </div>
        <div class="form-group" id="order">
          <ng-select
            [items]="statesArr"
            placeholder="Select"
            [searchable]="false"
            [clearable]="false"
            name="selectedstate"
            [(ngModel)]="state"
            (change)="onchangeState(state)"
            #selectedstate="ngModel"
          >
          </ng-select>
        </div>
      </div>
    </div>
    <div class="row pl-2 mb-4" *ngIf="displayInvoiceValueBoth()">
      <div
        class="custom-control custom-checkbox chkbox mb-0"
        style="
          margin-bottom: 0px !important;
          margin-top: 0 !important;
          border: none;
        "
      >
        <input type="checkbox" id="phoneCheck" class="custom-control-input" />
        <label
          class="custom-control-label font16 ml-2"
          style="
            cursor: pointer !important;
            line-height: 100%;
            font-size: 16px !important;
            font-weight: normal;
            color: black !important;
          "
          for="phoneCheck"
          >I agree to be contacted by or on behalf of
          {{ selectedProduct.energy_provider }} at the telephone number(s) provided about product and service offers, including via autodialed calls and text messages, and calls that use an artificial or prerecorded voice. I understand that I do not need to give this consent in order to purchase goods or services from {{ selectedProduct.energy_provider }}.</label
        >
      </div>
    </div>
    <div class="row pl-2">
      <div style="position: relative">
        <div
          class="clickable"
          (click)="onBlockClick()"
          id="buttondisclick"
        ></div>
        <div>
          <button
            style="width: 150px !important"
            id="theButton"
            class="btn next mr-2 ml-2 mt-2 mb-4 disabledButton font18 text-uppercase"
            [disabled]="disableBtn"
            [ngClass]="{ sectbtn: ngClass }"
            (click)="showAcceptances(f.form.valid);AllowClick()"
          >
            Next
          </button>
        </div>
      </div>
  
      <div id="clicks"></div>
    </div>
    <div class="col-sm-12 row" *ngIf="clickedOnce">
      <div
      class="alertMsg"
    >
    <span
    style="
    
   
    padding-left: 15px;
    "
    *ngIf="((f.submitted || firstnameChange) && fName.invalid && fName.errors.required) ||
    ((f.submitted || lastnameChange) && lName.invalid && lName.errors.required) ||
    ((f.submitted || phoneChange) && phoneNo.invalid && phoneNo.errors.required) ||
    ((f.submitted || emailChange) && email.invalid && email.errors.required) || 
    ((f.submitted || clickedOnce) && dobinvalid) ||
    (!isvalidEmail) ||
    ((f.submitted || clickedOnce) && invoiceInvalid) ||
    ((f.submitted || clickedOnce) && ssnInvalidmsg) ||
    ((f.submitted || clickedOnce) && howdidInvalid) 
          
    "
    >
      Following fields are required:
    </span>
    
    <ul>
      <li class="posabs" *ngIf="(f.submitted || firstnameChange) && fName.invalid && fName.errors.required">
        First Name is required
      </li>
      <li class="posabs" *ngIf="(f.submitted || lastnameChange) && lName.invalid && lName.errors.required">
        Last Name is required
      </li>
      <li class="posabs" *ngIf="(f.submitted || phoneChange) && phoneNo.invalid && phoneNo.errors.required">
        Phone Number is required
      </li>
      <li class="posabs" *ngIf="(f.submitted || clickedOnce) && dobinvalid">
        Date of Birth is required
      </li>
      <li class="posabs" *ngIf="(f.submitted || emailChange) && email.invalid && email.errors.required">
        Email is required
      </li>
      <li class="posabs" *ngIf="!isvalidEmail">
        Please enter a valid email
      </li>
      <li class="posabs" *ngIf="(f.submitted || clickedOnce) && invoiceInvalid">
        Invoice is required
      </li>
         <li class="posabs" *ngIf="(f.submitted || clickedOnce) && howdidInvalid">
        How did you hear about us is required
      </li>
      <li class="posabs" *ngIf="(f.submitted || clickedOnce) && ssnInvalidmsg">
        {{SSNValidationMsg}}
      </li>
      
    </ul>
      
    </div>
  
    </div>
  </div>
  <div class="webview" *ngIf="agreeBox">
    <div class="row col-sm-12 p-0 m-0">
      <h4 class="plan-heading pb-2">
        Here’s a bunch of legal stuff we have to make you aware of
      </h4>
      <div class="col-12 col-md-10 p-0 position-relative">
        <p class="font15 font-weight-normal-calibre lnhegt16 mb-4">
          You are legally authorized to enter into an agreement for electricity
          service and to select the Retail Electric Provider (REP) for the
          location provided in the previous step. You have read and understood
          the Terms of Service (TOS), Electricity Facts Label (EFL), and Your
          Rights As a Customer (YRAC). You understand that you can print and
          save these documents. You will receive copies of these documents in
          your confirmation email and may request additional copies by mail,
          email, or online any time by contacting your REP (<font
            class="providerClr"
            >{{ selectedProduct.energy_provider }}</font
          >).
        </p>
        <p class="font15 font-weight-normal-calibre lnhegt16 mb-4">
          You understand that enrollment for service can be made only by an
          applicant or the applicant’s authorized agent. In accordance with that
          requirement, I certify that I am at least 18 years of age and legally
          authorized to select or change Retail Electric Providers (REPS) for
          the address listed above.
        </p>
        <p
          class="font15 font-weight-normal-calibre lnhegt16 mb-4"
          *ngIf="selectedProduct.energy_provider != 'Chariot Energy'"
        >
          You authorize
          <font class="providerClr">
            {{ selectedProduct.energy_provider }}</font
          >
          to perform a credit check to determine if a deposit is required. If
          required, your total deposit will not exceed $300.
        </p>

        <p
          class="font15 font-weight-normal-calibre lnhegt16 mb-4"
          *ngIf="selectedProduct.energy_provider === 'Chariot Energy'"
        >
          You understand that by clicking on the Credit Check button immediately
          following this notice, you are providing 'written instructions' to
          <font class="providerClr">{{ selectedProduct.energy_provider }}</font>
          under the Fair Credit Reporting Act authorizing
          <font class="providerClr">{{ selectedProduct.energy_provider }}</font>
          to obtain information from your personal credit report or other
          information from a credit agency. You authorize
          <font class="providerClr">{{ selectedProduct.energy_provider }}</font>
          to obtain such information solely to determine if a deposit is
          required.
        </p>
        <p class="font15 font-weight-normal-calibre lnhegt16 mb-4">
          If you are switching REPs, you have the right to review and rescind
          the TOS without penalty within three (3) business days of receiving
          the TOS in your confirmation email. You may exercise the right by
          contacting
          <font class="providerClr">{{ selectedProduct.energy_provider }}</font>
          at
          <font class="providerClr">{{ selectedProduct.providerContact }}</font>
          or <font class="providerClr">{{ selectedProduct.providerEmail }}</font
          >. Their representatives are available:<br />
          <font class="providerClr">{{
            selectedProduct.providerOperationHours
          }}</font
          >.
        </p>
        <p class="font15 font-weight-normal-calibre lnhegt16 mb-4">
          You understand that an early termination fee will apply if you cancel
          your service before the end of your plan term.
        </p>
        <p class="font15 font-weight-normal-calibre lnhegt16 mb-4">
          If you experience a service outage any time during your agreement,
          please contact
          <font class="providerClr">{{ selectedProduct.utility_name }}</font> at
          <font class="providerClr">{{
            selectedProduct.utility_contact_number
          }}</font
          >.
        </p>
      </div>
    </div>
    <div
      class="row checkbox-ptpb-0"
      *ngIf="selectedProduct.energy_provider !== '4Change Energy'"
    >
      <div
        class="col-md-10 custom-control custom-checkbox chkboxtop chkbox ml-2 mt-0 pt-0"
        style="margin-bottom: 3px !important"
      >
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            id="acceptbtn1"
            style="padding-bottom: 0 !important"
            name="example1"
            [(checked)]="agreeBox1"
            (change)="checkboxEvnt($event, 'acceptbtn1')"
          />
          <label
            class="custom-control-label text-left align-top mb-0"
            for="acceptbtn1"
            style="
              line-height: 16px !important;
              font-size: 15px !important;
              padding-left: 0px !important;
              vertical-align: text-top;
              margin-top: 10px;
            "
            [innerHTML]="checkBoxText1"
          >
          </label>
        </div>
      </div>
    </div>
    <div class="row checkbox-ptpb-0">
      <div
        class="col-md-10 custom-control custom-checkbox chkboxtop chkbox ml-2 mt-0 pt-0"
        style="margin-bottom: 3px !important"
      >
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input pb-0"
            style="padding-bottom: 0 !important"
            id="acceptbtn2"
            name="example2"
            [(checked)]="agreeBox2"
            (change)="checkboxEvnt($event, 'acceptbtn2')"
          />
          <label
            class="custom-control-label text-left align-top mb-0"
            for="acceptbtn2"
            style="
              line-height: 16px !important;
              font-size: 15px !important;
              padding-left: 0px !important;
              vertical-align: text-top;
              margin-top: 10px;
            "
            [innerHTML]="checkBoxText2"
          >
          </label>
        </div>
      </div>
    </div>
    <div
      class="row checkbox-ptpb-0"
      *ngIf="selectedProduct.energy_provider === '4Change Energy'"
    >
      <div
        class="col-md-10 custom-control custom-checkbox chkboxtop chkbox ml-2 mt-0 pt-0"
        style="margin-bottom: 3px !important"
      >
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input pb-0"
            style="padding-bottom: 0 !important"
            id="acceptbtn4"
            name="example4"
            [(checked)]="agreeBox4"
            (change)="checkboxEvnt($event, 'acceptbtn4')"
          />
          <label
            class="custom-control-label text-left align-top"
            for="acceptbtn4"
            style="
              line-height: 16px !important;
              font-size: 15px !important;
              padding-left: 0px !important;
              vertical-align: text-top;
              margin-top: 10px;
            "
          >
            I have read, understand, and accept the
            <a
              href="https://www.4changeenergy.com/Docs/4Change-EZPay-Terms-Conditions.pdf"
              target="_blank"
              >Paperless Disclosures and Consent</a
            >. By enrolling, I agree to receive my bills, all documents
            regarding my service, and all other communications to the email
            address provided during this enrollment. I agree that I have
            provided 4Change Energy with a valid email address and understand
            that I will not receive any bills via regular postal mail.
          </label>
        </div>
      </div>
    </div>
    <div class="row checkbox-ptpb-0">
      <div
        class="col-md-10 custom-control custom-checkbox chkboxtop chkbox ml-2 mt-0 pt-0"
        style="margin-bottom: 3px !important"
      >
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input pb-0"
            style="padding-bottom: 0 !important"
            id="acceptbtn3"
            name="example3"
            [(checked)]="agreeBox3"
            (change)="checkboxEvnt($event, 'acceptbtn3')"
          />
          <label
            class="custom-control-label text-left align-top"
            for="acceptbtn3"
            style="
              line-height: 16px !important;
              font-size: 15px !important;
              padding-left: 0px !important;
              vertical-align: text-top;
              margin-top: 10px;
            "
          >
            By checking this box, you accept the terms and conditions of the
            Honest Gorilla
            <font
              class="bluclrr"
              style="cursor: pointer !important"
              (click)="openModalWithClass(template)"
            >
              Privacy Policy </font
            >and
            <font
              class="bluclrr"
              style="cursor: pointer !important"
              (click)="openModalWithClass(template1)"
              >Terms of Service</font
            >.
          </label>
        </div>
      </div>
    </div>
    <div class="row pl-2 mb-4">
      <button
        style="width: 150px !important"
        class="btn next mr-2 ml-2 mt-2 mb-4 disabledButton font18 text-uppercase"
        [disabled]="disableBtn"
        [ngClass]="{ sectbtn: ngClass }"
        (click)="next($event, f, f.form.valid)"
        id="submitBTN"
      >
      Submit
      </button>
    </div>
  </div>
  <div class="mobileview mt-4" id="acceptances">
    <div class="d-flex h-100 col-sm-12 px-0 m-0 flex-wrap" *ngIf="agreeBox">
      <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
        <img style="width: 100%" src="assets/images/signimg.jpg" />
      </div>
      <div class="col-sm-9 col-9 pr-0 my-auto pl-0">
        <div class="arrow_box">
          <h1 class="questionMob text-left">
            Here’s a bunch of legal stuff we have to make you aware of. Please
            read and agree to the statements below.
          </h1>
        </div>
      </div>
      <div class="col-sm-9 col-12 float-right m-auto mt-4 px-0 pt-3">
        <div class="col-12 p-0 position-relative">
          <p class="font15 font-weight-normal-calibre lnhegt16">
            You are legally authorized to enter into an agreement for
            electricity service and to select the Retail Electric Provider (REP)
            for the location provided in the previous step. You have read and
            understood the Terms of Service (TOS), Electricity Facts Label
            (EFL), and Your Rights As a Customer (YRAC). You understand that you
            can print and save these documents. You will receive copies of these
            documents in your confirmation email and may request additional
            copies by mail, email, or online any time by contacting your REP
            (<font class="providerClr">{{
              selectedProduct.energy_provider
            }}</font
            >).
          </p>
          <p
            class="font15 font-weight-normal-calibre lnhegt16"
            style="margin: 10px 0"
            *ngIf="selectedProduct.energy_provider === 'Chariot Energy'"
          >
            You understand that by clicking on the Credit Check button
            immediately following this notice, you are providing 'written
            instructions' to
            <font class="providerClr">{{
              selectedProduct.energy_provider
            }}</font>
            under the Fair Credit Reporting Act authorizing
            <font class="providerClr">{{
              selectedProduct.energy_provider
            }}</font>
            to obtain information from your personal credit report or other
            information from a credit agency. You authorize
            <font class="providerClr">{{
              selectedProduct.energy_provider
            }}</font>
            to obtain such information solely to determine if a deposit is
            required.
          </p>

          <p
            class="font15 font-weight-normal-calibre lnhegt16"
            style="margin: 10px 0"
            *ngIf="selectedProduct.energy_provider !== 'Chariot Energy'"
          >
            You authorize
            <font class="providerClr">
              {{ selectedProduct.energy_provider }}</font
            >
            to perform a credit check to determine if a deposit is required. If
            required, your total deposit will not exceed $300.
          </p>

          <p class="font15 font-weight-normal-calibre lnhegt16">
            If you are switching REPs, you have the right to review and rescind
            the TOS without penalty within three (3) business days of receiving
            the TOS in your confirmation email. You may exercise the right by
            contacting
            <font class="providerClr">{{
              selectedProduct.energy_provider
            }}</font>
            at
            <font class="providerClr">{{
              selectedProduct.providerContact
            }}</font
            >,
            <font class="providerClr">{{ selectedProduct.providerURL }}</font>
            or
            <font class="providerClr">{{ selectedProduct.providerEmail }}</font
            >. Their representatives are available:
            <font class="providerClr">{{
              selectedProduct.providerOperationHours
            }}</font
            >.
          </p>

          <p
            class="font15 font-weight-normal-calibre lnhegt16"
            style="margin: 10px 0"
          >
            You understand that an early termination fee will apply if you
            cancel your service before the end of your plan term.
          </p>
          <p class="font15 font-weight-normal-calibre lnhegt16">
            If you experience a service outage any time during your agreement,
            please contact
            <font class="providerClr">{{ selectedProduct.utility_name }}</font>
            at
            <font class="providerClr">{{
              selectedProduct.providerContact
            }}</font
            >.
          </p>
        </div>
        <div
          class="row mt-2 checkbox-ptpb-0"
          *ngIf="selectedProduct.energy_provider !== '4Change Energy'"
        >
          <div
            class="custom-control custom-checkbox chkboxtop chkbox ml-2"
            style="margin-bottom: 0 !important"
          >
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                id="acceptbtn1"
                name="example1"
                [(checked)]="agreeBox1"
                (change)="checkboxEvnt($event, 'acceptbtn1')"
              />
              <label
                class="custom-control-label text-left align-top"
                for="acceptbtn1"
                style="
                  line-height: 16px !important;
                  font-size: 15px !important;
                  padding-left: 0px !important;
                  vertical-align: text-top;
                  margin-top: 10px;
                "
                [innerHTML]="checkBoxText1"
              ></label>
            </div>
          </div>
        </div>
        <div class="row checkbox-ptpb-0">
          <div
            class="custom-control custom-checkbox chkboxtop chkbox ml-2"
            style="margin-bottom: 0 !important"
          >
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                id="acceptbtn2"
                name="example2"
                [(checked)]="agreeBox2"
                (change)="checkboxEvnt($event, 'acceptbtn2')"
              />
              <label
                class="custom-control-label text-left align-top"
                for="acceptbtn2"
                style="
                  line-height: 16px !important;
                  font-size: 15px !important;
                  padding-left: 0px !important;
                  vertical-align: text-top;
                  margin-top: 10px;
                "
                [innerHTML]="checkBoxText2"
              >
              </label>
            </div>
          </div>
        </div>
        <div
          class="row checkbox-ptpb-0"
          *ngIf="selectedProduct.energy_provider === '4Change Energy'"
        >
          <div
            class="col-md-10 custom-control custom-checkbox chkboxtop chkbox ml-2 mt-0 pt-0"
            style="margin-bottom: 3px !important"
          >
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input pb-0"
                style="padding-bottom: 0 !important"
                id="acceptbtn4"
                name="example4"
                [(checked)]="agreeBox4"
                (change)="checkboxEvnt($event, 'acceptbtn4')"
              />
              <label
                class="custom-control-label text-left align-top"
                for="acceptbtn4"
                style="
                  line-height: 16px !important;
                  font-size: 15px !important;
                  padding-left: 0px !important;
                  vertical-align: text-top;
                  margin-top: 10px;
                "
              >
                I have read, understand, and accept the
                <a
                  href="https://www.4changeenergy.com/Docs/4Change-EZPay-Terms-Conditions.pdf"
                  target="_blank"
                  >Paperless Disclosures and Consent</a
                >. By enrolling, I agree to receive my bills, all documents
                regarding my service, and all other communications to the email
                address provided during this enrollment. I agree that I have
                provided 4Change Energy with a valid email address and
                understand that I will not receive any bills via regular postal
                mail.
              </label>
            </div>
          </div>
        </div>
        <div class="row checkbox-ptpb-0">
          <div class="custom-control custom-checkbox chkboxtop chkbox ml-2">
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                id="acceptbtn3"
                name="example3"
                [(checked)]="agreeBox3"
                (change)="checkboxEvnt($event, 'acceptbtn3')"
              />
              <label
                class="custom-control-label text-left align-top"
                for="acceptbtn3"
                style="
                  line-height: 16px !important;
                  font-size: 15px !important;
                  padding-left: 0px !important;
                  vertical-align: text-top;
                  margin-top: 10px;
                "
              >
                By checking this box, you accept the terms and conditions of the
                Honest Gorilla
                <font
                  class="bluclrr"
                  style="cursor: pointer !important"
                  (click)="openModalWithClass(template)"
                >
                  Privacy Policy </font
                >and
                <font
                  class="bluclrr"
                  style="cursor: pointer !important"
                  (click)="openModalWithClass(template1)"
                  >Terms of Service</font
                >.</label
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 px-0 text-center" *ngIf="checkBoxValidation()">
            <button
              id="lastFinal"
              class="btn mr-2 ml-2 next mt-2 font18 text-uppercase sectbtn"
              (click)="next($event, f, f.form.valid)"
               id="submitBTN"
            >
            Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
<ng-template #template>
  <div class="modal-header py-0">
    <div class="col-12 text-right py-0 px-0">
      <button
        type="button"
        class="close pull-right borderNone"
        aria-label="Close"
        (click)="modalRef.hide()"
      >
        <div _ngcontent-c5="" class="float-right mr-1 mt-1">
          <img src="assets/images/editchart-close.svg" width="20" />
        </div>
      </button>
      <br />
      <h4 class="modal-title pull-left semi-bold font20 webview">
        Honest Gorilla Privacy Policy
      </h4>
      <h4 class="modal-title pull-left semi-bold font20 mobileview">
        Privacy Policy
      </h4>
    </div>
  </div>
  <div class="modal-body">
    <section class="mb-2 mt-2 text-left pb-2">
      <p class="privpoltxt font-weight-normal-calibre">
        Effective Date: October 2, 2019
      </p>
      <p class="privpoltxt font-weight-normal-calibre">
        We, Honest Gorilla Inc., and our corporate affiliates (“we” or “us”),
        value and respect your privacy and are committed to protecting any
        personal information that you may provide us through your use of our
        website. This privacy policy (“Policy”) outlines which information may
        be collected when you (“you” or “your”) access and use the Website from
        either a desktop or mobile device (www.honestgorilla.com and any
        subdomains thereto as “Site”, or “Website”), the products and services
        provided by us (which, together, are referred to as the “Services”), and
        how we protect and use it, and under what circumstances we may disclose
        the information to third parties and affiliated business partners. This
        Policy also wishes to make sure that you are aware of the options
        available to you when you access and use our Services.
      </p>

      <p class="privpoltxt font-weight-normal-calibre">
        We encourage you to please take a moment to familiarize yourself with
        the Policy before using our Services. By accessing or using our
        Services, you are accepting and consenting to the use of your
        information as described in this Policy and to our Terms of Service. If
        you do not agree to either this Policy or Terms of Service, in part or
        in whole, then we ask that you terminate your use and refrain from using
        our Services or accessing any information contained herein.
      </p>
      <h3 class="privpoltxt">Collection of Personal Information:</h3>
      <p class="privpoltxt font-weight-normal-calibre">
        Keeping your information private and secure is incredibly important to
        us. In keeping with our intent to be honest with our users and
        customers, the following paragraphs explain what we intend to collect
        and why we collect it, so that you can make informed decisions how you
        choose to interact with us and use our Services. Of course, the
        information that we collect from you depends upon the information that
        you provide, which sections of the Service you visit and what actions
        you choose to take during your visit. Please note: we only collect data
        and information of stuff we need, and we only share when we feel it’s
        necessary to help and improve or enhance your experience at any time,
        now or in the future.
      </p>

      <h3 class="privpoltxt">Information you provide:</h3>
      <p class="privpoltxt font-weight-normal-calibre">
        Honest Gorilla Inc. collects information from you when you choose to
        share it with us to use our Services, whether to enroll for service,
        make a purchase, create an online account, request more information from
        us, sign up for our newsletter or ask to be included in our email list,
        post a comment or review, participate in a survey or promotion, or
        otherwise contact or interact with us. The information we collect may
        include your name, address, email address, telephone number, social
        security number, driver’s license number, birthday, gender, transcripts
        of any communications, purchase information and any other information
        you provide to us when accessing the Site. We may combine the
        information you provide to us with information (1) from and about you
        that we automatically collect when you use this or other sites
        affiliated with Honest Gorilla Inc. (2) from third-parties, or (3) from
        other online and offline sources. Whether or not you provide any of this
        information is your sole decision to make; however, in many instances
        the information being requested is required to participate in the
        particular activity, realize a benefit we may offer, or gain access to
        certain content or parts of our Website.
      </p>

      <div class="rounded webview">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="font15 semi-bold text-center">
                Personal info you provide
              </th>
              <th scope="col" class="font15 semi-bold text-center">
                Why we collect it
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="font15 font-weight-normal-calibre text-left">
                Your name, date of birth, service address, billing address,
                ESIID, meter number, authorized representative, social security
                number and/or driver’s license number
              </td>
              <td class="font15 font-weight-normal-calibre text-left">
                We transmit this info via encrypted lines of electronic
                communication to your energy provider so that they can perform
                necessary steps to pre-qualify and enroll you for service on
                their designated platform.
              </td>
            </tr>
            <tr>
              <td class="font15 font-weight-normal-calibre text-left">
                Your email address
              </td>
              <td class="font15 font-weight-normal-calibre text-left">
                This is part of the account creation process and how we connect
                with you. It’s also the primary method that we will contact you
                with product and service updates, availability, and news-related
                communications.
              </td>
            </tr>
            <tr>
              <td class="font15 font-weight-normal-calibre text-left">
                Your phone number
              </td>
              <td class="font15 font-weight-normal-calibre text-left">
                If there’s ever a need to contact you beyond email, then we will
                call you. We may also share your phone number with the energy
                provider you have chosen or other service providers who have a
                business reason to reach you.
              </td>
            </tr>

            <tr>
              <td class="font15 font-weight-normal-calibre text-left">
                Your home, household, lifestyle and energy usage details,
                account and credit details, energy plan preferences, contract
                details
              </td>
              <td class="font15 font-weight-normal-calibre text-left">
                The more we know about your home, what’s in it and how you use
                energy, the better we can recommend solutions to you and enhance
                our product and service offering or connect you with affiliated
                resources that can be of benefit.
              </td>
            </tr>
            <tr>
              <td class="font15 font-weight-normal-calibre text-left">
                Your business, operations, ownership and energy usage details,
                account and credit details, energy plan preferences, contract
                details
              </td>
              <td class="font15 font-weight-normal-calibre text-left">
                The more we know about your business, what’s in it, who owns it
                and how you use energy, the better we can recommend solutions to
                you and enhance our product and service offering or connect you
                with affiliated resources that can be of benefit.
              </td>
            </tr>
            <tr>
              <td class="font15 font-weight-normal-calibre text-left">
                Facebook, Gmail, or other social media account
              </td>
              <td class="font15 font-weight-normal-calibre text-left">
                This may be your preferred method for account creation and to
                invite others to use or share with them about your experience
                with Honest Gorilla. You may also use Facebook or Gmail to
                connect with Honest Gorilla as an easier way to access our
                Services or to invite others to Honest Gorilla.
              </td>
            </tr>
            <tr>
              <td class="font15 font-weight-normal-calibre text-left">
                Contact / Address book
              </td>
              <td class="font15 font-weight-normal-calibre text-left">
                Inviting others to use Honest Gorilla via your contact list may
                ease the process.
              </td>
            </tr>
            <tr>
              <td class="font15 font-weight-normal-calibre text-left">
                App and device usage statistics
              </td>
              <td class="font15 font-weight-normal-calibre text-left">
                We may collect data from your desktop or mobile device. We
                aggregate and anonymize this data to look for statistical
                patterns that can help us give you, and all of our users, more
                precise information and help improve overall performance of the
                Site and user experience.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="rounded mobileview text-center"
        style="float: left; width: 100%"
      >
        <div style="float: left; width: 100%">
          <table class="table">
            <thead>
              <tr>
                <th scope="col" class="font15 semi-bold text-center">
                  Personal info you provide
                </th>
                <th scope="col" class="font15 semi-bold text-center">
                  Why we collect it
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="font15 font-weight-normal-calibre text-left">
                  Your name, date of birth, service address, billing address,
                  ESIID, meter number, authorized representative, social
                  security number and/or driver’s license number
                </td>
                <td class="font15 font-weight-normal-calibre text-left">
                  We transmit this info via encrypted lines of electronic
                  communication to your energy provider so that they can perform
                  necessary steps to pre-qualify and enroll you for service on
                  their designated platform.
                </td>
              </tr>
              <tr>
                <td class="font15 font-weight-normal-calibre text-left">
                  Your email address
                </td>
                <td class="font15 font-weight-normal-calibre text-left">
                  This is part of the account creation process and how we
                  connect with you. It’s also the primary method that we will
                  contact you with product and service updates, availability,
                  and news-related communications.
                </td>
              </tr>
              <tr>
                <td class="font15 font-weight-normal-calibre text-left">
                  Your phone number
                </td>
                <td class="font15 font-weight-normal-calibre text-left">
                  If there’s ever a need to contact you beyond email, then we
                  will call you. We may also share your phone number with the
                  energy provider you have chosen or other service providers who
                  have a business reason to reach you.
                </td>
              </tr>

              <tr>
                <td class="font15 font-weight-normal-calibre text-left">
                  Your home, household, lifestyle and energy usage details,
                  account and credit details, energy plan preferences, contract
                  details
                </td>
                <td class="font15 font-weight-normal-calibre text-left">
                  The more we know about your home, what’s in it and how you use
                  energy, the better we can recommend solutions to you and
                  enhance our product and service offering or connect you with
                  affiliated resources that can be of benefit.
                </td>
              </tr>
              <tr>
                <td class="font15 font-weight-normal-calibre text-left">
                  Your business, operations, ownership and energy usage details,
                  account and credit details, energy plan preferences, contract
                  details
                </td>
                <td class="font15 font-weight-normal-calibre text-left">
                  The more we know about your business, what’s in it, who owns
                  it and how you use energy, the better we can recommend
                  solutions to you and enhance our product and service offering
                  or connect you with affiliated resources that can be of
                  benefit.
                </td>
              </tr>
              <tr>
                <td class="font15 font-weight-normal-calibre text-left">
                  Facebook, Gmail, or other social media account
                </td>
                <td class="font15 font-weight-normal-calibre text-left">
                  This may be your preferred method for account creation and to
                  invite others to use or share with them about your experience
                  with Honest Gorilla. You may also use Facebook or Gmail to
                  connect with Honest Gorilla as an easier way to access our
                  Services or to invite others to Honest Gorilla.
                </td>
              </tr>
              <tr>
                <td class="font15 font-weight-normal-calibre text-left">
                  Contact / Address book
                </td>
                <td class="font15 font-weight-normal-calibre text-left">
                  Inviting others to use Honest Gorilla via your contact list
                  may ease the process.
                </td>
              </tr>
              <tr>
                <td class="font15 font-weight-normal-calibre text-left">
                  App and device usage statistics
                </td>
                <td class="font15 font-weight-normal-calibre text-left">
                  We may collect data from your desktop or mobile device. We
                  aggregate and anonymize this data to look for statistical
                  patterns that can help us give you, and all of our users, more
                  precise information and help improve overall performance of
                  the Site and user experience.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
    <section class="mb-2 mt-2 text-left pb-2">
      <h3 class="privpoltxt">
        General Information automatically collected about you
      </h3>
      <p class="privpoltxt">
        This is any information that is deemed anonymous in nature and does not
        personally identify you as an individual. We collect General Information
        by using cookies, web beacons, and similar tools; it may include your
        unique IP address, mobile device identifier, browser type, carrier name,
        the URL of the last webpage you visited before visiting the Site, and
        actions undertaken on the Website when you visit. The purpose of
        collecting this information is to give us insight on how people use our
        Services, possibly resulting in us tailoring advertisements on the Site
        to you based on your online activities or preferences or recommend
        solutions that could be of benefit to you. You are welcome to opt out of
        our use of cookies, web beacons and other tools at any time. You can
        learn more about how do to so at the Digital Advertising
        Alliance’s Webchoices page, European Advertising Standards Alliance
        (EASA)’s Framework and the Network Advertising Initiative’s Consumer Opt
        Out page.
      </p>

      <h3 class="privpoltxt">
        Information collected from social media related content
      </h3>
      <p class="privpoltxt">
        Our Website includes features that allows you to share information to
        various social media services. Your use of these sharing features may
        result in the collection or sharing of information about you by these
        sites and other third-parties according to the respective social media
        service providers’ own privacy policy. If you log into your Honest
        Gorilla account through a social media platform, we may access and store
        information through interfaces provided by the platforms in accordance
        with each platform’s policies.
      </p>

      <h3 class="privpoltxt">Information automatically collected</h3>
      <p class="privpoltxt">
        We may use cookies, web beacons, pixel tags, log files, local shared
        objects (Flash cookies), and other technologies to automatically collect
        certain information about you in order to operate and optimize our
        Website but also to deliver rich content, including online
        advertisements that we think would be more relevant to your interests
        and needs, and to monitor interactions with our emails and online
        advertisements. We may elect to use third-party advertisements and ad
        networks to support our Site.
      </p>

      <p class="privpoltxt">
        If you are concerned about your privacy, then you may setup your browser
        not to accept cookies, or you can opt-in to delete them from your hard
        drive and browser history once you leave the Sites. However, this can
        affect the way in which you are able to interact with our Sites as well
        as any other website.
      </p>

      <p class="privpoltxt">
        As a condition of using this Website and Honest Gorilla’s Services, you
        agree to the collection and storage of all of the above referenced
        information. You also agree that we may use this information for the
        purposes referred to herein and may share this information with other
        businesses for the purposes referred to and the terms set out herein.
      </p>

      <h3 class="privpoltxt">How will Honest Gorilla use my information</h3>
      <p class="privpoltxt">
        We may use the information we collect from and about you, either
        directly or indirectly, for any of the following purposes:
      </p>

      <p class="privpoltxt">
        • To fulfill service requests, place orders and communicate with our
        energy providers, third-party service products and customers; <br />
        • To research and develop new products and services;<br />
        • To respond to your inquiries;<br />
        • To provide to you and other users with customized website content,
        targeted offers and advertising on this Website;<br />
        • To contact you when necessary;<br />
        • To review the usage and operations of our Websites and improve our
        content, products and services;<br />
        • To address any issues or problems users may be experiencing with the
        Website or our business;<br />
        • To promote our Services and the Site;<br />
        • To protect the security and integrity of our Services, the Site and
        our business;<br />
      </p>

      <p class="privpoltxt">
        We may also disclose personally identifiable information we collect to
        companies that perform services or functions on our behalf – such as
        marketing services or consulting services – and to other companies with
        which we have joint marketing agreements.
      </p>

      <p class="privpoltxt">
        Joint marketing agreements with other companies allow us to bring
        information to you about products and services that are different from
        those we provide. We require our service providers and those with which
        we jointly market products or services to adhere to confidentiality
        standards governing the privacy of your information. These companies may
        use and disclose the information we provide to them only for the
        purposes for which it is provided or as otherwise permitted by law. We
        will not sell or exchange personally identifiable information about you
        with outside marketers or other companies to allow them to independently
        solicit you for their products or services without giving you the
        opportunity to decline to have your personally identifiable information
        provided to such outside marketers or other companies. We may also use
        personal information on an aggregated basis (so that individual
        information is not known) to understand how to improve our products and
        services. You have a right to review the personally identifiable
        information we have gathered and to identify any inaccurate information
        we have on file. If you would like to review this information, please
        send us a request by e-mail to hello@honestgorilla.com
      </p>

      <h3 class="privpoltxt">How will third-parties use my information</h3>
      <p class="privpoltxt">
        All Services are provided by affiliated third-parties. When choosing to
        enroll, subscribe or purchase Services from us or any service provider,
        you must take into consideration that you will be transacting business
        directly with the service provider. The information provided will be
        similar to information that would be provided pursuant to a purchase of
        such product or service by telephone or in-person.
      </p>

      <p class="privpoltxt">
        We provide your personal and purchase information to third-party service
        providers, as necessary, to enroll you in the selected product or
        service. While it is our intention to only work with reputable service
        providers, we encourage you to review the privacy policy of the
        third-party service provider you are contemplating selecting. Honest
        Gorilla is not responsible for the privacy statements of other service
        providers, nor are we responsible for the security of personal
        information used to enroll you in third-party services, and are not
        liable for losses resulting from third-party service provider data
        breaches.
      </p>

      <h3 class="privpoltxt">
        Location information and other information from devices
      </h3>
      <p class="privpoltxt">
        When you use the Honest Gorilla Website, from a mobile device or desktop
        computer, we will collect and use information about you in generally
        similar ways and for similar purposes. In addition, we may collect
        information about your location. We may use the location information
        collected from your device to enhance your use of Honest Gorilla’s
        Services by providing you with relevant content and contextual
        advertising. You can change the privacy settings of your device at any
        time in order to turn off the functionality to share location
        information through the Website. Please note that turning off location
        sharing may affect certain features of our Services. Though we may
        identify your geographic location, we do not receive your personal
        information. We identify your location only to provide a more tailored
        experience for you.
      </p>
      <h3 class="privpoltxt">
        What information will Honest Gorilla share with others
      </h3>
      <p class="privpoltxt">
        We may disclose the personal information we collect from and about you
        as follows: (1) the service provider that operates this Website and its
        affiliated companies; (2) to other service providers, if the disclosure
        will enable them to perform a business, professional or technical
        support function for us; (3) as necessary if we believe that there has
        been a violation of our rights or the rights of any third party; (4) to
        respond to judicial process and provide information to law enforcement
        or regulatory agencies or in connection with an investigation on matters
        related to public safety, as permitted by law, or otherwise as required
        by law; (5) to our select partners that we believe may have offers of
        interest to you; (6) to promote our Services to third-parties; and (7)
        as described to you at the point of such information collection.
      </p>

      <p class="privpoltxt">
        We may choose to sell or purchase assets during the normal course of
        business. If another entity acquires us or any of our assets,
        information we have collected about you may be transferred to such
        entity. In addition, if any bankruptcy or reorganization proceeding is
        brought by or against us, such information may be considered an asset of
        ours and may be sold or transferred to third-parties. Should such a sale
        or transfer occur, we will use reasonable efforts to try to require that
        the transferee use personal information provided through the Website in
        a manner that is consistent with this Policy.
      </p>
      <p class="privpoltxt">
        We will share certain personal information that we collect from and
        about you with our business partners, energy providers, third-party
        service providers, and with other third-parties with whom we partner
        (including cloud storage and web hosting providers, marketers, and
        software maintenance service providers) in order to run our service,
        optimize your experience, and to resolve any incidents that may occur.
        For example, you may contact us letting us know that you’re experiencing
        difficulties enrolling for Services, and we may have to share your
        information with a partner to ensure satisfactory resolution of any
        issues experienced. We will not share any of your financial institution
        payment information with any third-party other than your selected energy
        provider.
      </p>
      <p class="privpoltxt">
        Each energy provider handles their own customer service and billing and
        may use your information in accordance with their own privacy policies.
        Some of the third-parties described above, including Google, may use
        your location and other personal information to serve advertisements to
        you on other websites unrelated to Honest Gorilla.
      </p>
      <p class="privpoltxt">
        We may also share non-personally identifiable information in order to
        improve our modeling, algorithms, or user experience and perform
        aggregate reporting, including use of Google Analytics and other related
        services provided by Google or others. Third-parties, such as Facebook,
        may use cookies, web beacons and other storage technologies to collect
        or receive information from our Website and use that information to
        recognize users and assess traffic patterns, compile aggregate
        statistics, determine effectiveness of our campaigns and provide
        targeted or retargeted ads.
      </p>

      <p class="privpoltxt">
        We may enter into agreements with third-parties to share some of the
        non-personally identifiable information we collect on the Website.
        Should you decide to customize your results or account using actual
        data, or if you request price quotes for a business, we may access your
        usage data, meter number, and premise identification number through an
        automated interface maintained by your utility or other third-party and
        we may share this information with various energy providers. We may also
        share your energy usage information, predicted future electricity usage
        information, the expected cost of the plans presented to you, as well as
        information about the pages you requested insofar as that information is
        relevant to showing which plans you were interested in and which plans
        you clicked on. This is intended to provide our business partners with
        insight into how our Website operates, how their plans compare with
        other plans on our Website, which users are attracted to which types of
        plans presented, and/or how different households use energy. All of this
        information will be provided without specifics related to your service
        address, ESIID, meter number, email address, phone number or other
        relevant and personally identifiable information.
      </p>

      <p class="privpoltxt">
        We may also disclose other personal information or other information
        about you (i) to law enforcement, courts or regulators; (ii) to exercise
        or protect our legal rights; or (iii) in the course of a business
        transaction in which we buy or sell certain assets. If we enter into an
        agreement to sell substantially all of our business assets, or if we
        become insolvent or enter into bankruptcy, then your personal
        information may be transferred to a third-party. In any of these cases,
        your personal information could continue to be used by a successor or
        purchaser entity in the manner forth in this Policy.
      </p>
      <h3 class="privpoltxt">How do you protect my information</h3>
      <p class="privpoltxt">
        We restrict access to your information to our employees and others whom
        we feel must operate in a need-to-know basis and use it to provide our
        products and services.
      </p>

      <h3 class="privpoltxt">
        What information about me is shared with Light of Unity
      </h3>
      <p class="privpoltxt">
        By being a customer of Honest Gorilla you are helping to advance our
        mission of transforming energy from a commodity to a means for social
        good. You can choose to share information about the cause or initiative
        that we are assisting through the Light of Unity, however, we will never
        share your personal information in an identifiable manner with any
        recipient without your consent or permission. All contributions or
        assistance will be made as a collective body of all our customers and
        never draw attention or cause identification of any individual or
        personal information to be disclosed.
      </p>

      <h3 class="privpoltxt">
        How does Honest Gorilla communicate with its customers
      </h3>
      <p class="privpoltxt">
        We primarily message our customers through email or our Website. Certain
        email communications related to your account and questions must be
        delivered and do not include an unsubscribe option. Please ensure that
        the email address you provide and we have on record is accurate. You can
        manage notification settings through your user settings in the Website.
      </p>
      <h3 class="privpoltxt">How secure is my privacy</h3>
      <p class="privpoltxt">
        The security of personal information is important to us. We have taken
        certain physical, administrative and technical steps to safeguard the
        information we collect from and about our customers and Website
        visitors. While we make every effort to ensure the integrity of our
        network and systems, please remember that no method of transmission over
        the Internet, or method of electronic storage is 100% secure. Our
        Website uses an SSL Certificate, and while we strive to use commercially
        acceptable means to protect your personal information, we cannot
        guarantee its absolute security.
      </p>
      <h3 class="privpoltxt">What happens when I cancel my account</h3>
      <p class="privpoltxt">
        You may cancel your Honest Gorilla account on our Website at any time.
        We may retain all information you provide to us for as long as we deem
        necessary to fulfill a business purpose or comply with a legal request.
      </p>
      <p class="privpoltxt">
        You may, at any time, (1) configure your browser to opt out of the
        Website’s placement of cookies on your computer; (2) withdraw any
        consent you previously gave us, or object to the processing of your
        personal information by following the contact method described below –
        this may prevent you from using certain elements of the Services; (3)
        stop receiving commercial emails from us by clicking the “unsubscribe”
        link at the bottom of the email – this will not prevent or interfere
        with us sending you non-marketing transactional communications. You may
        exercise these rights by contacting us as provided below or in other
        written communications we may send you.
      </p>
      <h3 class="privpoltxt">Third-Party Links and Cross-Linking</h3>
      <p class="privpoltxt">
        The Site may include links to our business partners’ websites or other
        affiliated sites. These links are provided for your convenience and do
        not constitute an endorsement. If you choose to provide any information
        to any of these entities, they will collect and use your information
        pursuant to their own privacy policies, over which we have no control.
        Additionally, we may use third-party advertisements placed by ad
        networks to support our Site and enhance the user experience. Some of
        these advertisers or ad networks may place a cookie or similar
        technology on your computer or mobile device in order to provide you
        with relevant advertisements based on your online behavior. These
        third-party sites have separate and independent privacy policies. We
        therefore have no responsibility or liability for the content and
        activities of these linked sites
      </p>
      <h3 class="privpoltxt">Tracking Technology and Do-Not-Track Requests</h3>
      <p class="privpoltxt">
        We along with several service providers with whom we work may employ
        certain pieces of technology that tracks your online activities using
        our Services and on third-party websites. We currently offer no response
        to Do-Not-Track requests transmitted by web browsers. Additionally, we
        have no control over the activities of third-party, advertising, or
        service provider practices and they may employ technology that tracks
        your activity on our Website.
      </p>

      <h3 class="privpoltxt">Who should use Honest Gorilla’s Website</h3>
      <p class="privpoltxt">
        Protecting the privacy of children is especially important to us. Our
        product and services are intended for anyone 18 years of age and older.
        If a service provider requires a birthdate to order a specific product
        or service, you will not be able to enter a birth date that indicates
        that you are less than 18 years old. We do not market any products or
        services to children under the age of 13 or knowingly collect any
        information from children under the age of 13. If we become aware that
        information is or has been submitted by or collected from a child under
        the age of 13, we will delete this information and cancel that user’s
        account and/or access to the Services.
      </p>
      <h3 class="privpoltxt">California Residents</h3>
      <p class="privpoltxt">
        In addition to the rights set forth in this Policy, residents of
        California may request information about the types of personal
        information we share with third-parties for direct marketing purposes,
        and the entities of the third-parties with whom we have shared such
        information during the immediately preceding calendar year. California
        Residents may request further information about our compliance with this
        law by sending us a request to the email address provided below. We will
        respond to one such request per customer each year, and we cannot and
        will not reply to requests made by any means other than those described
        below.
      </p>
      <h3 class="privpoltxt">
        Will Honest Gorilla ever change this Privacy Policy
      </h3>
      <p class="privpoltxt">
        As Honest Gorilla expands and evolves, we may find it necessary to
        update this Policy. Regardless what we change, we will always maintain
        our commitment to protecting your privacy. We will post all revisions,
        along with their effective dates. We recommend that you check this page
        every so often to make sure you’re familiar with the latest policy. We
        will ask for your consent to policy changes, if required by applicable
        law; in other cases, please note that your continued use of the Service
        after any change means that you agree with, and consent to be bound by,
        the new Privacy Policy, current and actively in effect.
      </p>
      <h3 class="privpoltxt">How do I contact Honest Gorilla</h3>
      <p class="privpoltxt">
        We welcome your comments regarding this Policy. If you have any
        questions, please email us at hello@honestgorilla.com
      </p>
    </section>
  </div>
</ng-template>
<ng-template #template1>
  <div class="modal-header py-0">
    <div class="col-12 text-right modal-border py-0 px-0">
      <button
        type="button"
        class="close pull-right borderNone"
        aria-label="Close"
        (click)="modalRef.hide()"
      >
        <div _ngcontent-c5="" class="float-right mr-1 mt-1">
          <img src="assets/images/editchart-close.svg" width="20" />
        </div>
      </button>
      <br />
      <h4 class="modal-title pull-left semi-bold font20 webview">
        Honest Gorilla Terms of Service
      </h4>
      <h4 class="modal-title pull-left semi-bold font20 mobileview">
        Terms of Service
      </h4>
    </div>
  </div>
  <div class="modal-body">
    <section class="mb-2 mt-2 text-left pb-2">
      <p class="termsofsertxt font-weight-normal-calibre">
        Last updated: October 07, 2019
      </p>
      <p class="termsofsertxt font-weight-normal-calibre">
        Hello! Thanks for showing interest in learning more about the Honest
        Gorilla Terms of Service. This is a legal agreement between you and
        Honest Gorilla Inc. and shall govern your experience while using our
        platform. Please read this document carefully and in its entirety before
        using our website and accessing, purchasing or registering for any
        products and services.
      </p>

      <h3 class="privpoltxt">ACCEPTANCE OF TERMS</h3>
      <p class="privpoltxt">
        By using and/or visiting the
        <a
          style="color: blue; text-decoration: underline"
          href="https://www.honestgorilla.com/"
          target="_blank"
          >www.honestgorilla.com</a
        >
        website, chatbot service or any other domains or subdomains owned by
        Honest Gorilla Inc. (as defined below), or any successor website or
        service of the Company (collectively the “Website”) then you (“You”)
        acknowledge that You have read, understood and agree to be bound by
        these Terms of Service (“Terms”).
      </p>
      <p class="privpoltxt">
        These Terms, together with the
        <a
          style="color: blue"
          href="https://www.honestgorilla.com/faq/privacy-policy"
          target="_blank"
          >Privacy Policy</a
        >, constitute an agreement (the “Agreement”) between You and Honest
        Gorilla Inc. and its parents, subsidiaries, affiliates, successors and
        assigns (collectively “Honest Gorilla”, “Company”, “we” or “us”) and is
        binding in full force and effect. You are authorized only to use the
        Website if You agree to be bound by and party to these Terms and all
        applicable laws. If You do not agree unconditionally to any of these
        Terms, in whole or in part, please discontinue using and/or visiting the
        Website, now or in the future.
      </p>

      <h3 class="privpoltxt">DESCRIPTION OF SERVICES</h3>
      <p class="privpoltxt">
        Honest Gorilla, among other things, is an online marketplace for energy
        plan comparison shopping (“Service”). The Service provides You with
        tools and resources that allow You to make an informed decision about
        which energy plan (“Energy Plan”) to choose from based on a series of
        inputs You provide regarding your household, lifestyle or business needs
        and usage profile. The Service then shops the third-party Retail Energy
        Providers (“REPs”) the Company has relationships with and makes
        recommendations for You.
      </p>
      <p class="privpoltxt">
        All information that You provide must be to the best of your knowledge.
        Any information that we assume, deduce, infer or imply may be loosely
        based on similar customers who fit a similar description or profile.
        This is especially true in cases where we may have access to limited
        information.
      </p>
      <p class="privpoltxt">
        All information presented on this Website is
        <span style="text-decoration: underline"
          >intended for general educational purposes only</span
        >. To safeguard the Company’s interests, we do not warrant or guaranty
        the accuracy of any information. Be sure to read, review and understand
        the details of the Energy Plan before making a decision to enroll. You
        can find all pertinent documents related to each Energy Plan
        conveniently located on the Website.
      </p>
      <p class="privpoltxt">
        Choosing to enroll in an Energy Plan offered by a REP which You learn
        about by using our Website, and your interaction with any REP accessed
        through this Website, is your sole decision to make and is to be done at
        your own risk. Your contractual relationship will be with the REP of
        your choosing and not with Honest Gorilla. We are not responsible or
        liable to You or any other visitor of the Website in any way including,
        without limitation, any disputes arising out of the Energy Plan contract
        between You and the REP, including disputes related to whether the
        parties have fully performed their obligations and any disputes related
        to whether a contract has been validly entered into or concluded.
      </p>
      <p class="privpoltxt">
        Honest Gorilla does not and has no responsibility for the quality of the
        services You receive from any such REP or affiliated third-party
        provider. Should You find yourself having made a wrong purchasing
        decision or experience buyer’s remorse, please consult the respective
        REP or third-party service provider’s terms of service agreement for
        procedures how to terminate or rescind your agreement, or to return
        merchandise or ask for a refund.
      </p>
      <p class="privpoltxt">
        Honest Gorilla does not represent or imply that this Website contains a
        complete or comprehensive list or choice of all REPs or solutions that
        can provide service to You at your particular address. This site may
        exclude certain REPs that do not meet our proprietary standards or
        protocols for electronic integration. Accordingly, there may be REPs
        that can provide service at your particular address but do not appear on
        our Website and are not listed as a choice for You to select on this
        Website. You are in no way obligated to use this Website or to choose
        any particular REP that appears on the Website.
      </p>
      <p class="privpoltxt">
        All prices listed on the Website are expressed in U.S. Dollars.
      </p>
      <p class="privpoltxt">
        Please refer to a later section of these Terms for additional
        disclaimers and for more information on how we present REPs’ Energy
        Plans and how we are compensated.
      </p>
      <p class="privpoltxt">
        Additional and optional products and services may also be purchased on
        our Website or through third-party affiliate links. The price and other
        terms remain subject to service agreements between You and the
        respective third-party provider. Honest Gorilla cannot guarantee the
        price, quality and/or service provided by any third-party vendor.
      </p>
      <h3 class="privpoltxt">ACCESS TO SERVICES</h3>
      <p class="privpoltxt">
        Not all of the products or services described on this Website are
        available in all areas of the United States, and You may not be eligible
        for them. We reserve the right to determine eligibility and
        availability. The Company may, at its sole discretion and without notice
        or liability, change, suspend or discontinue the Website or impose
        limits on certain features and services, or restrict your access to
        parts or all of the Website. We reserve the right to update, in our sole
        discretion, to change or replace any or all parts of these Terms by
        sending You a notice or by posting on the Website a notice informing You
        of any updates and/or changes. It is your responsibility to check this
        page periodically for changes. Your continued use or access of the
        Website shall constitute your consent to be bound by the Terms then in
        effect, as amended. You can review the most recent version of the Terms
        at any time at this location.
      </p>
      <p class="privpoltxt">
        Any new features, tools, products or services which are added to the
        Website shall also be subject to these Terms. Although we strive to make
        the Website available as much as possible, there may be periods of
        downtime (for example, scheduled maintenance, software updates, product
        updates, service enhancements, or events outside of our reasonable
        control).
      </p>
      <h3 class="privpoltxt">ESTABLISHING A USER ACCOUNT AND SECURITY</h3>
      <p class="privpoltxt">
        In order to use some or all aspects of the Website, or to save your
        information for later use, You must register and maintain an active
        personal user account (“User Account”). When You sign up for a User
        Account on our Website, You must select a unique username and password
        and agree that You will provide true, accurate, complete and updated
        contact information, identification details and any other form of
        authentication that Honest Gorilla may require or request from You in
        its sole discretion. We reserve the right to suspend, terminate or
        suspend your account and refuse any and all current or future use of the
        Website or Services (or any portion thereof) if you provide any untrue,
        inaccurate, not current or incomplete information, or if we reasonably
        suspect that you have provided untrue, inaccurate, not current or
        incomplete information.
      </p>
      <p class="privpoltxt">
        User Account registration requires You to submit certain personal
        information, such as your name, email address, and mobile phone number
        as part of our security procedures. You are solely responsible for
        maintaining the confidentiality of your Honest Gorilla User Account
        password and account information and for restricting access to your
        computer or mobile device. You agree to have full responsibility for all
        activities that occur under your User Account or Password Login
        information. Your failure to maintain accurate, complete, and up-to-date
        Account information may result in your inability to access and use the
        Services. You also agree to ensure that you exit from your account at
        the end of each session. You should use particular caution when
        accessing your account from a public or shared computer so that others
        are not able to view or record your password or other personal
        information.
      </p>
      <p class="privpoltxt">
        Should You wish to terminate your Honest Gorilla account, You may do so
        in writing by emailing us at
        <span
          style="color: blue; text-decoration: underline"
          (click)="mailMe('hello@honestgorilla.com')"
          >hello@honestgorilla.com</span
        >. In our sole discretion, we reserve the right to refuse service,
        terminate accounts, remove or edit content, or cancel accounts for any
        reason. The Terms shall remain binding and in full effect and
        enforceable after your account is terminated by us.
      </p>
      <h3 class="privpoltxt">FEES AND COMPENSATION PAYMENTS</h3>
      <p class="privpoltxt">
        Use and access of the Website is made available to all visitors free of
        charge. All of the REPs presented on the Website have certain agreements
        in place with Honest Gorilla to market and promote their Energy Plans in
        exchange for compensation when visitors choose to enroll in a certain
        advertised Energy Plan.
      </p>
      <p class="privpoltxt">
        In cases where compensation is a factor that can cause those Energy
        Plans to appear in any of our Featured or Sponsored portions of the
        Website and/or affect the placement, ranking or order of the Energy
        Plan’s appearance in the search results and comparison features of the
        Website, then they will be designated as such. Otherwise, it is our
        desire and intent to promote products and services that rank according
        to the best or cheapest offer being recommended or presented first.Other
        such factors include the Energy Plans’ price, quality of the REP’s
        content, variety of Energy Plan offerings, REP ratings and reviews, REP
        complaint history with the governing public utility commission, REPs’
        deposit policies, REPs’ fee(s), and other factors that we believe are
        useful. Some REPs also pay us to place advertisements or make
        considerations for product placement in addition for a fee.
      </p>
      <p class="privpoltxt">
        When making a request through the Website, You understand and agree to
        the following:<br />
        • That we will share your personal information with the REP You have
        chosen to qualify, process and fulfill your service request. Please
        refer to our
        <a
          style="color: blue"
          href="https://www.honestgorilla.com/faq/privacy-policy"
          target="_blank"
          >Privacy Policy</a
        >
        for any questions regarding which information we collect and how it is
        used and for what purposes.<br />
        • We are not a REP and do not undertake a credit analysis or make credit
        decisions in association with the Service. To determine or assess a
        deposit is the sole decision and discretion of the REP.<br />
        • We are not a party to any agreement that You may make with any
        participating REP whom You choose to use or from whom You ultimately
        receive energy service.<br />
        • The participating REP(s) whom You contract to service You is solely
        responsible for its services to You.<br />
      </p>
      <p class="privpoltxt">
        Any compensation we may receive is paid by the participating service
        provider for advertising services we provide to them. We do not charge
        You a fee to use the Website. You understand that the requirements for a
        particular service are made by the participating service providers and
        we do not endorse, warrant, or guarantee the products or services of any
        such third-party provider.
      </p>
      <p class="privpoltxt">
        You agree that we shall not be liable for any damages or costs of any
        type which arise out of or in connection with your use of the service
        provider’s products or services. You also give us permission to send You
        periodic updates of services and products which may be of interest or
        pertain to You. Please note that information we provide You either on
        the Website or by email may not be used as the sole basis for your
        decision to retain a particular service provider, and if their services
        may not meet your particular needs.
      </p>
      <p class="privpoltxt">
        The supplier that You have chosen has the final authority to complete
        the agreement. They may choose not to honor the pricing and/or terms due
        to credit review, energy usage review or other reasons outside of our
        control. If the supplier does not fulfill or complete the agreement as
        presented, we will notify You and provide You with alternative options
        for your approval before proceeding.
      </p>
      <p class="privpoltxt">
        Pursuant to the Terms of Service, Electricity Facts Label, Your Rights
        as a Customer and any other legally binding document for the Energy Plan
        You have chosen, your entire contractual relationship will be with that
        specific REP that is offering your Energy Plan. Your interaction with
        any REP accessed through our Website, for credit check and verification
        purposes or enrollment, is at your own risk. Honest Gorilla does not
        have any responsibility and will not bear any liability for the quality
        of the services rendered or that You receive from any REP.
      </p>

      <h3 class="privpoltxt">
        ACCEPTANCE OF RETAIL MERCHANDISE PRODUCT ORDERS
      </h3>
      <p class="privpoltxt">
        We reserve the right, at our discretion, to refuse or cancel any retail
        merchandise order from being processed at any time and for any reason.
        For your convenience, for any merchandise products that are ordered on
        the Website, You will be charged upon ordering and your order will be
        shipped within the time stated on the product specific page or mentioned
        under the ‘Shipping and Returns’ and/or ‘International Shipping’ pages
        of the Website. Your order may be cancelled due to, but is not limited
        to, limitations on quantities available for purchase, inaccuracies or
        errors in product or pricing information, or credit or fraud problems.
        We will contact You if any portion of your order is cancelled or if
        additional information is required to accept your order. If your order
        is cancelled after we have received payment, we will issue a credit by
        the charged payment method for the amount of the charge.
      </p>
      <h3 class="privpoltxt">
        ORDER QUANTITY LIMITATIONS ON RETAIL MERCHANDISE
      </h3>
      <p class="privpoltxt">
        We reserve the right to limit the quantity of items purchased per
        person, per household, or per order. These restrictions may be
        applicable to orders placed by the same payment account and also to
        orders that use the same billing and/or shipping address, or same email
        address. We will provide notification to the customer email and/or
        billing address provided should such limits be applied. We also reserve
        the right to prohibit sales to dealers or other corporations or
        institutions. If You are interested in purchasing multiple quantities of
        items for a corporation or institution, please contact us through our
        “Contact Us” page on the Website.
      </p>
      <h3 class="privpoltxt">LICENSE</h3>
      <p class="privpoltxt">
        Honest Gorilla hereby grants You a non-exclusive, non-transferable,
        revocable, limited license to access and use the Website, its tools and
        resources, under the terms set forth herein. The Website, together with
        the content, including, but not limited to, images, photos, animations,
        videos, graphics, text, data, reports, calculators, articles, opinions,
        software (including HTML-based computer programs), affiliate links,
        graphs and charts (collectively the “Content”) displayed on the Website
        may be used for your personal and non-commercial use only. Except as
        otherwise permitted under these Terms of Service, You hereby agree not
        to copy, reproduce, reverse-engineer, modify, create derivative works
        from, or store any Content, in whole or in part, from the Website or to
        display, perform, publish, distribute, transmit, broadcast or circulate
        any Content to any entity, persons, corporation or institutions, or for
        any commercial purpose, without the express prior written consent of
        Honest Gorilla.
      </p>
      <p class="privpoltxt">
        The trademarks, service marks, names and logos (collectively,
        “Trademarks”) used and displayed on this Website are registered and
        unregistered marks of Honest Gorilla and others. Nothing on this website
        should be construed as granting, by implication, estoppel, or otherwise,
        any license or right to use any Trademark. Honest Gorilla aggressively
        enforces its intellectual property rights to the fullest extent of the
        law. Honest Gorilla’s Trademarks may not be used in any way, including
        in advertising or publicity pertaining to distribution of materials on
        this website, without our prior, written permission. To request
        permission to use the Trademarks or Content on the Website, or any other
        Honest Gorilla material, please contact us at
        <span
          style="color: blue; text-decoration: underline"
          (click)="mailMe('hello@honestgorilla.com')"
          >hello@honestgorilla.com</span
        >.
      </p>
      <h3 class="privpoltxt">TERMINATION OF LICENSE</h3>
      <p class="privpoltxt">
        Honest Gorilla reserves the right to terminate the License granted
        herein and deny You access to any portion of it in its sole discretion,
        without any advance notice or liability to You, for any reason. Honest
        Gorilla also reserves the right to investigate any suspected violations
        of these Terms or refer to law enforcement authorities any behavior that
        we believe may violate these Terms or applicable law. If your License is
        terminated for any reasons, we reserve the rights, in our sole
        discretion, to: (i) remove your profile from the Website; and (ii)
        remove and discard any of your submitted Content. The termination of
        your License and account will not affect any additional right or relief
        to which Honest Gorilla may be entitled, at law or in equity. Upon
        termination of these Terms, all rights granted to You will automatically
        terminate and immediately revert to Honest Gorilla.
      </p>
      <h3 class="privpoltxt">GENERAL PROHIBITIONS</h3>
      <p class="privpoltxt">You may not do any of the following:</p>
      <p class="privpoltxt">
        1. Copy, modify, create a derivative work of, reverse-engineer,
        reverse-assemble, steal, change, copy, or otherwise attempt to discover
        any source code, underlying ideas or algorithms of the Website or any of
        the products and services made available on the Website;<br />
        2. Remove or obscure the copyright notice or other notices displayed,
        “framed” or “mirrored” in connection with the Content accessible through
        the Website or any of the products and services made available on the
        Website;<br />
        3. Interfere with or disrupt the Website, its servers and networks
        connected to the Website, or circumvent, disable, thwart, redirect or
        otherwise interfere with security-related features of the Website or
        features that prevent or restrict use of any Content or that enforce
        limitations on use of the Website;<br />
        4. Modify the Website in any form or manner, or use modified versions
        thereof;<br />
        5. Sell, assign, license, sublicense or otherwise transfer any right in
        the Website or Content through the Website <br />
        6. Use any robot, spider, scraper, crawler, offline reader, site
        search/retrieval application or other manual or automated means to
        access, retrieve, index, data mine or in any way reproduce or circumvent
        the navigational structure or presentation of the Website or its
        contents for any purpose without our prior written consent;<br />
        7. Take any action that imposes or may impose an unreasonable or
        disproportionately large load on the Honest Gorilla systems, networks or
        infrastructure; or <br />
        8. Knowingly disseminate or transmit any worms, moles, viruses, Trojan
        horses, logic bombs, or other harmful, disruptive, defective, malicious
        or destructive files, code, programs or other similar or related
        technologies, or otherwise utilize the Website in any manner that
        violates any statute, rule or regulation.<br />
        9. Attempt to gain unauthorized access to, interfere with, damage, or
        disrupt any parts of the Website, the server on which the Website is
        stored, or any server, computer, or database connected to the
        Website.<br />
      </p>

      <h3 class="privpoltxt">
        CONSENT TO COMMUNICATIONS VIA EMAIL AND TEXT MESSAGES
      </h3>
      <p class="privpoltxt">
        By creating an Account, You agree that the Services may send you
        informational emails and text (SMS) messages as part of the normal
        business operation of your use of the Services. You may opt-out of
        receiving emails and text (SMS) messages from Honest Gorilla at any
        time. By doing so, You acknowledge that opting-out of receiving emails
        and text (SMS) messages, You may impact your use of the Services.
      </p>
      <h3 class="privpoltxt">LINKING POLICIES</h3>
      <p class="privpoltxt">
        This Website contains links to other websites. Honest Gorilla is not
        responsible for the content of such websites including any changes or
        updates that are made to the linked website or the accuracy or
        completeness of the information provided on those websites. Honest
        Gorilla has provided links as a convenience to You, and the existence of
        the links on this Website does not imply that Honest Gorilla approves of
        or is affiliated with the linked organization or company, or its
        products or services, or that the linked organization or company
        approves of or is affiliated with Honest Gorilla. Honest Gorilla does
        not vouch for those persons, companies or organizations whose goods or
        services may be accessed or displayed through or on the Website.
      </p>
      <p class="privpoltxt">
        (a) Inbound Links: Honest Gorilla grants You the revocable permission to
        link to publicly available portions of the Website; provided, however,
        that any site which incorporates a link to this Website must not: (i)
        create a browser or border environment around any of the Content on the
        Website or otherwise mirror any part of the Website; (ii) imply that
        Honest Gorilla is endorsing, sponsoring or promoting the site or any
        products or services offered by or through such site; (iii) present
        false information about, disparage, or otherwise harm Honest Gorilla or
        any other company, affiliate, organization, service or provide described
        on the Honest Gorilla Website or Service; (iv) use any Trademarks of
        Honest Gorilla or of any other organization without the prior written
        permission from the trademark’s owner; (v) or contain content that
        Honest Gorilla in its sole opinion deems offensive or otherwise
        objectionable. In addition, the site must be owned, operated and
        controlled by You or the entity placing the link, otherwise permit You
        to enable such link to be subject to these Terms. By linking to the
        Website, You agree always to comply with these Terms, liable to use for
        any damages (statutory, punitive or otherwise) relating to your
        violation of these Terms, and to indemnify us as provided in this
        section.<br />
        (b) Outbound Links: this Website may include outbound links to websites
        that are not owned, operated or controlled by Honest Gorilla, and are
        subject to different terms and conditions. If You follow outbound links,
        You will be legally bound by the terms and conditions of those other
        websites. Any outbound links are provided solely to enhance your
        experience with Honest Gorilla and are for your reference, and do not
        endorse or indicate an affiliation with any other organization. Honest
        Gorilla makes no representations whatsoever concerning those other
        organizations, or any products or services they may offer.
      </p>
      <h3 class="privpoltxt">NO WARRANTY</h3>
      <p class="privpoltxt">
        Honest Gorilla has no special relationship with or fiduciary duty to
        You. You acknowledge that Company has no control over, and no duty to
        take any action regarding: which users gain access to the Services; what
        Content You access via the Services; what effects the Content may have
        on You; how You may interpret or use the Content; or what actions You
        may take as a result of having been exposed to the Content. You release
        Honest Gorilla from all liability for You having acquired or not
        acquired Content through the Services. The Services may contain, or
        direct You to websites containing, information that some people may find
        offensive or inappropriate. Honest Gorilla makes no representations
        concerning any content contained in or accessed through the Services,
        and Honest Gorilla will not be responsible or liable for the accuracy,
        copyright compliance, legality or decency of material contained in or
        accessed through the Services. Honest Gorilla makes no representations
        or warranties regarding the accuracy of descriptions anywhere on the
        Services, or regarding suggestions or recommendations of services or
        products offered or purchased through the Services. Products and
        services purchased (whether or not following such recommendations and
        suggestions) are provided “AS IS” without any warranty of any kind from
        Honest Gorilla or others unless, with respect to others (only),
        otherwise made expressly and unambiguously in writing by a designated
        third party for a specific product or service. THE SERVICES, CONTENT,
        WEBSITE, PRODUCTS AND SERVICES OBTAINED THROUGH THE WEBSITE, AND ANY
        SOFTWARE ARE PROVIDED ON AN "AS IS" BASIS, WITHOUT WARRANTIES OF ANY
        KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION, IMPLIED
        WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
        NON-INFRINGEMENT, OR THAT USE OF THE SERVICES WILL BE UNINTERRUPTED OR
        ERROR-FREE. HONEST GORILLA MAKES NO GUARANTEES OR WARRANTIES AS TO THE
        ACCURACY, COMPLETENESS, TIMELINESS OR CURRENTNESS OF THE SITE, THE
        SITE’S CONTENT, OR ANY MATERIAL THAT CAN BE ACCESSED (VIA A DIRECT OR
        INDIRECT HYPERLINK OR OTHERWISE) THROUGH THE WEBSITE.SOME STATES DO NOT
        ALLOW LIMITATIONS ON HOW LONG AN IMPLIED WARRANTY LASTS, SO THE ABOVE
        LIMITATIONS MAY NOT APPLY TO YOU.
      </p>
      <p class="privpoltxt">
        OUR ESTIMATES OF AND COMPARISONS BETWEEN REP ENERGY PLANS INCLUDE ALL
        THE RECURRING CHARGES THAT YOU WILL SEE ON YOUR REP’S ENERGY BILL
        EXCLUDING GOVERNMENT FEES AND TAXES, BUT WE CANNOT AND DO NOT GUARANTEE
        THAT OUR ESTIMATES OR COMPARISONS ARE ACCURATE OR THAT THE SERVICES
        OFFERED BY REPS ON OUR SERVICE ARE THE BEST OR LOWEST-PRICED SERVICES
        AVAILABLE TO YOU. THE REPS APPEARING ON OUR SERVICE ARE INDEPENDENT
        THIRD PARTIES EXCEPT TO THE EXTENT EXPRESSLY DESCRIBED IN THESE TERMS.
        YOUR ACTUAL PRICES FOR THE SELECTED PLANS WILL BE DETERMINED BY YOUR
        INDIVIDUAL USAGE, INFORMATION FOUND IN THE “ELECTRICITY FACTS LABEL”
        MANDATED BY THE RESPECTIVE GOVERNING PUBLIC UTILITY COMMISSION AND REPS’
        CUSTOMER AGREEMENTS, AND OTHER FACTORS OUTSIDE AND BEYOND OUR CONTROL.
      </p>
      <p class="privpoltxt">
        THE DISCLAIMERS IN THIS SECTION APPLY TO THE FULLEST EXTENT PERMITTED
        UNDER LOCAL LAW.
      </p>
      <h3 class="privpoltxt">LIMITATION OF LIABILITY AND RELEASE</h3>
      <p class="privpoltxt">
        In no event shall Honest Gorilla be liable to You or any other party for
        any indirect, special, exceptional, incidental, consequential, or
        punitive damages, however and wherever arising, that may result from
        your use of the Website or the Honest Gorilla Service, including without
        limitation to losses incurred due to: (a) any inaccurate information
        published on the site or any site accessible via an outbound link; (b)
        software glitches, server failures, power outages, or any other issue
        beyond Honest Gorilla’s control; (c) any delays in or failure of the
        Website to operate as described; (d) any unauthorized disclosure of
        account information that may occur through the actions of any
        third-party, such as hackers; (e) any damage to your website code,
        browsing experience, or Content resulting from your use of our API; (f)
        damages or losses of any kind resulting from actions You take in
        reliance upon any results or other information provided by the Website
        or Service; and (g) any other damages or losses You may incur in
        connection with your use of the Honest Gorilla Website or Service.
      </p>
      <p class="privpoltxt">
        IN NO EVENT WILL HONEST GORILLA’S TOTAL LIABILITY TO YOU FOR ALL
        DAMAGES, LOSSES OR CAUSES OR ACTION RELATING TO THE WEBSITE AND/OR THE
        SERVICE EXCEED NINETEEN UNITED STATES DOLLARS ($19.00) OR THE MINIMUM
        LIABILITY ALLOWED BY RELEVANT LAW, WHICHEVER IS GREATER.
      </p>
      <p class="privpoltxt">
        Honest Gorilla is not responsible for examining or evaluating the
        business practices, action, omissions, or services of participating
        Retail Energy Providers or third-party product or service providers.  If
        You elect to establish an account with a REP on this site, You agree
        that You will first carefully review the terms and conditions of that
        REP’s service.  IN THE EVENT OF A DISPUTE BETWEEN YOU AND A REP LISTED
        ON THE WEBSITE, TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, YOU
        RELEASE HONEST GORILLA, ITS SUBSIDIARIES, AFFILIATES, OFFICERS,
        DIRECTORS, EMPLOYEES, AGENTS, AND LEGAL REPRESENTATIVES FROM AND AGAINST
        CLAIMS AND DAMAGES OF ANY KIND, KNOWN AND UNKNOWN, SUSPECTED AND
        UNSUSPECTED, DISCLOSED AND UNDISCLOSED, ARISING OUT OF OR IN ANY WAY
        CONNECTED WITH SUCH A DISPUTE, NOW OR IN THE FUTURE.
      </p>
      <p class="privpoltxt">
        If You are a California resident, by using the Site, You explicitly
        waive the rights granted to You under California Civil Code 1542, which
        states: “A general release does not extend to claims which the creditor
        does not know or suspect to exist in his favor at the time of executing
        the release, which, if known by him must have materially affected his
        settlement with the debtor.”  If You are a New Jersey resident, certain
        sections of these Terms may not apply to You pursuant to the New Jersey
        Truth in Consumer Contract, Warranty, and Notice Act.  Additional states
        may not allow this exclusion or limitation of liability, so the
        limitation or exclusion stated herein may not apply to You.
      </p>
      <h3 class="privpoltxt">LIMITATION OF ACTIONS</h3>
      <p class="privpoltxt">
        We will use our best efforts to include accurate and up-to-date
        information on the Website, but we make no warranties or representations
        as to the accuracy or completeness of the information You agree that
        your access and use of the site and its contents is at your own risk.
        Any claim or cause of action arising out of your use of the Service must
        be filed within one (1) year after such claim or cause of action arose
        or it shall forever be barred, notwithstanding any statute of
        limitations or other law to the contrary. Within this period, any
        failure by Honest Gorilla to enforce or exercise any provision of this
        Terms of Service or any related right shall not constitute a waiver of
        that right or provision.
      </p>
      <h3 class="privpoltxt">USER COMMENTS AND FEEDBACK</h3>
      <p class="privpoltxt">
        If You send, with or without a request from us, certain specific
        submissions that include creative ideas, suggestions, proposals, plans,
        or other materials, whether online, by email, by postal mail, or
        otherwise (collectively, ‘comments’), You agree that we may, at any time
        and without restriction, edit, copy, publish, distribute, translate and
        otherwise use in any medium any comments that You forward to us. We are
        and shall be under no obligation (1) to maintain any comments in
        confidence; (2) to pay compensation for any comments; or (3) to respond
        to any comments.
      </p>
      <h3 class="privpoltxt">INDEMNIFICATION</h3>
      <p class="privpoltxt">
        You are entirely responsible for maintaining the confidentiality of your
        username(s), password(s), and your account(s), as well as all activities
        that occur under your account(s). You agree to protect, defend, and hold
        harmless Honest Gorilla from and against any and all claims, suits,
        liabilities, and expenses arising in any way out of claims based upon
        your use of the Website or by anyone using your information. BY USING
        AND/OR VISITING THE WEBSITE, YOU AGREE TO DEFEND, INDEMNIFY AND HOLD
        HARMLESS HONEST GORILLA AND ITS OFFICERS, DIRECTORS, EMPLOYEES,
        CONTRACTORS, AGENTS, LICENSORS, AND SERVICE OR CONTENT PROVIDERS FROM
        AND AGAINST ANY AND ALL LOSSES, LIABILITIES, EXPENSES, DAMAGES AND
        COSTS, INCLUDING REASONABLE ATTORNEYS’ FEES AND COURT COSTS, ARISING OR
        RESULTING FROM YOUR USE OF THE WEBSITE AND ANY VIOLATION OF THESE TERMS
        OF SERVICE. IF YOU CAUSE A TECHNICAL DISRUPTION OF THE SITE OR THE
        SYSTEMS TRANSMITTING THE SITE TO YOU OR OTHERS, YOU AGREE TO BE
        RESPONSIBLE FOR ANY AND ALL LOSSES, LIABILITIES, EXPENSES, DAMAGES AND
        COSTS, INCLUDING REASONABLE ATTORNEYS’ FEES AND COURT COSTS, ARISING OR
        RESULTING FROM THAT DISRUPTION, INTERRUPTION OR INTERFERENCE OF SERVICE.
      </p>
      <h3 class="privpoltxt">COPYRIGHT</h3>
      <p class="privpoltxt">
        All information and Content on this Website, including logos, graphics,
        photos, icons, videos, animations, code, script, sound, images and text
        (“Website Materials”) and any intellectual property rights embodied
        therein are the property of Honest Gorilla or third-party providers of
        information that appears on the Website. Unless otherwise stated herein,
        none of the Website Materials may be copied, reproduced, modified,
        distributed, sold, broadcast, downloaded, stored or otherwise used
        without the express permission of Honest Gorilla or the original
        copyright holder. You may display and print Website Materials solely for
        your personal, non-commercial use, provided that You do not modify the
        Website Materials and that You retain all copyright and other
        proprietary notices contained in them.
      </p>
      <p class="privpoltxt">
        Honest Gorilla or its suppliers may provide software available for
        download on the Website. Use of software provided on the Website is
        protected by copyright law and governed by the terms of the end user
        license agreement that accompanies such software. You may not install or
        use any software that contains an end user license agreement unless You
        first agree to the terms of the end user license agreement.
      </p>
      <p class="privpoltxt">
        Honest Gorilla encourages You to report any content on the Website that
        You believe infringes your rights.  Only the intellectual property
        rights owner or person authorized to act on behalf of the owner can
        report potentially infringing content. If You have a good faith belief
        that content on the Website infringes your copyright, trademark, or
        other intellectual property rights, please follow the procedures set
        forth below.  Under the U.S. Digital Millennium Copyright Act, our
        designated copyright agent for notice of alleged copyright infringement
        appearing on the Services can be contacted at <span
          style="color: blue; text-decoration: underline"
          (click)="mailMe('hello@honestgorilla.com')"
          >hello@honestgorilla.com</span
        >
      </p>
      <p class="privpoltxt">
        We reserve the right to remove any content alleged to be infringing
        without prior notice, at our sole discretion, and without liability to
        You, and/or to terminate your account if it is determined that You
        knowingly posted infringing content.
      </p>

      <h3 class="privpoltxt">CHOICE OF LAW; FORUM</h3>
      <p class="privpoltxt">
        This document shall be governed and construed accordance with and in all
        respects by the laws of the United States and the State of Delaware
        without regard to the conflict of laws and provisions thereof. Any claim
        or dispute You may have against us, whether subject to mandatory
        arbitration or otherwise, must be brought in Dallas, Texas.  For any
        matters not subject to mandatory arbitration, You agree to submit to the
        personal jurisdiction of the courts located within Dallas County, Texas
        for the purpose of litigating all such claims or disputes.
      </p>
      <p class="privpoltxt">
        Should You file a claim other than as specified here, we may recover
        reasonable attorneys’ fees and costs, provided that we have notified You
        in writing of the improperly filed claim and You have failed to withdraw
        the claim promptly.
      </p>

      <h3 class="privpoltxt">ARBITRATION AGREEMENT AND CLASS WAIVER</h3>
      <p class="privpoltxt">
        You agree to arbitrate all disputes and claims that arise out of or
        relate to your use of the Website, regardless of when those disputes or
        claims arise. Therefore, You agree that, by using the Website, YOU ARE
        WAIVING THE RIGHT TO A TRIAL BY JURY OR TO PARTICIPATE IN ANY CLASS
        ACTION BASED ON OR INVOLVING CLAIMS BROUGHT IN A PURPORTED
        REPRESENTATIVE CAPACITY ON BEHALF OF THE GENERAL PUBLIC, OTHER USERS, OR
        PERSONS SIMILARLY SITUATED. Any arbitration proceeding brought under
        this section shall be conducted by an arbitration service provider
        chosen by Honest Gorilla applying Texas law. The arbitration may be
        conducted telephonically, with the costs to be split evenly between the
        parties.
      </p>

      <h3 class="privpoltxt">MODIFICATION AND NOTICE OF CHANGES</h3>
      <p class="privpoltxt">
        Honest Gorilla reserves the right to modify the information contained on
        this Website or these Terms of Service at any time and without notice.
        Using and/or visiting this Website after any changes to these Terms of
        Service have been posted thereon will constitute your agreement to the
        revised Terms. Unless specifically stated otherwise, any new features,
        products or services added to the website shall be subject to these
        Terms.
      </p>
      <h3 class="privpoltxt">INDEPENDENCE</h3>
      <p class="privpoltxt">
        Notwithstanding any assistance provided by the Parties to each other in
        implementing the Terms to maximize value to both parties, the parties
        hereby acknowledge and agree that they are, and will in implementing
        these Terms be, acting independently. Nothing herein is intended to or
        will make the parties joint venturers, partners or otherwise authorizes
        a party to act on behalf of the other or otherwise bind the other.
      </p>
      <h3 class="privpoltxt">ENTIRE AGREEMENT</h3>
      <p class="privpoltxt">
        This Terms of Service and any document incorporated by reference herein
        constitute the entire agreement between You and us and govern your use
        of the Service, superseding any prior agreements between us.
      </p>
      <h3 class="privpoltxt">HEADINGS</h3>
      <p class="privpoltxt">
        Headings contained in these Terms are for convenience only and shall not
        be construed to define or limit and terms herein, or otherwise affect
        the meaning or interpretation of this Terms.
      </p>
      <h3 class="privpoltxt">SEVERABILITY</h3>
      <p class="privpoltxt">
        If any provision of these Terms of Service is found by a court or other
        binding authority to be invalid, the remaining provisions shall continue
        in full force and effect.
      </p>
      <h3 class="privpoltxt">HOW TO CONTACT US</h3>
      <p class="privpoltxt">
        If You have any questions, complaints or concerns regarding this Terms
        of Service, You may contact us by email at
        <span
          style="color: blue; text-decoration: underline"
          (click)="mailMe('hello@honestgorilla.com')"
          >hello@honestgorilla.com</span
        >
      </p>
    </section>
  </div>
</ng-template>

<ng-template #template2>
  <div>
    <button
      type="button"
      class="close pull-right borderNone closeModelAlign"
      aria-label="Close"
      (click)="modalRef.hide()"
    >
      <div _ngcontent-c5="" class="float-right mt-1 mr-3">
        <img src="assets/images/editchart-close.svg" width="17" />
      </div>
    </button>
    <div class="modal-header pl-5 pr-5 pt-5">
      <div class="col-12 py-0 px-0 modal-border">
        <h4 class="modal-title semi-bold font20">
          Receive Important Billing Notices from Chariot Energy
        </h4>
        <span style="font-size: 15px !important"
          >(Bill Due Date, Late Payment, Avoid Disconnections etc)</span
        >
      </div>
    </div>
    <div class="modal-body pl-5 pr-5 pb-5">
      <p class="font15 linehgt">
        I hereby consent to receive important text messages from or on behalf of
        Chariot Energy at the telephone number listed above. I understand that
        this consent is not a condition of purchasing any goods or services from
        Chariot Energy. Message and data rates may apply. Message frequency
        varies. Reply HELP for help. Reply STOP to opt out. See Terms of Service
        for more details. Click here
        <a
          style="color: blue"
          href="https://chariotenergy.com/privacy-policy/"
          target="_blank"
          >(https://chariotenergy.com/privacy-policy/)</a
        >
        to see our privacy policy.
      </p>
    </div>
  </div>
</ng-template>

<ng-template #template3>
  <div>
    <button
      type="button"
      class="close pull-right borderNone closeModelAlign"
      aria-label="Close"
      (click)="modalRef.hide()"
    >
      <div _ngcontent-c5="" class="float-right mt-1 mr-3">
        <img src="assets/images/editchart-close.svg" width="17" />
      </div>
    </button>
    <div class="modal-header pl-5 pr-5 pt-5">
      <div class="col-12 py-0 px-0 modal-border">
        <h4 class="modal-title semi-bold font20">
          Receive Important Account Notices
        </h4>
        <span style="font-size: 15px !important"
          >(Contract Expirations, Renewals, Energy Saving Tips, Special Plan
          Offers etc)</span
        >
      </div>
    </div>
    <div class="modal-body pl-5 pr-5 pb-5">
      <p class="font15 linehgt">
        I hereby consent to receive important text messages from or on behalf of
        Honest Gorilla at the telephone number listed above. I understand that
        this consent is not a condition of purchasing any goods or services from
        Honest Gorilla. Message and data rates may apply. Message frequency
        varies. Reply HELP for help. Reply STOP to opt out. See Terms of Service
        for more details. Click here
        <a
          style="color: blue"
          href="https://www.honestgorilla.com/faq/privacy-policy/"
          target="_blank"
          >(https://www.honestgorilla.com/faq/privacy-policy/)</a
        >
        to see our privacy policy.
      </p>
    </div>
  </div>
</ng-template>
<ng-template #newEnergyRates>
  <div id="serviceunavialbe">
    <div class="modal-header pr-1 pt-1">
      <div class="col-12 text-right py-0 px-0">
        <button
          type="button"
          class="close pull-right borderNone closeModelAlign"
          aria-label="Close"
          (click)="newEnergyProviderRates()"
        >
          <div _ngcontent-c5="" class="float-right mr-1 mt-1">
            <img src="assets/images/editchart-close.svg" width="17" />
          </div>
        </button>
      </div>
    </div>
    <div class="modal-body pt-0">
      <h4 class="utility-modal-title font20 text-center text-uppercase">
        THIS OFFER HAS EXPIRED
      </h4>
      <p class="utility-sub-title font20">
        PRICE FLASH! Due to market volatility, this price is no longer being
        offered by the energy provider you have selected. However, this update
        could possibly work in your favor!
      </p>
      <br />
      <p class="utility-sub-title font20">
        Click the button below 👇 to see new rates.
      </p>
      <br />
      <p class="utility-sub-title font20">
        We appreciate your patience, and apologize In advance for any
        inconvenience, while we update our records. This may take a few seconds.
      </p>
      <div class="col-12 text-center">
        <button
          class="btn mr-2 ml-2 col-12 font-weight-bold-calibre contbtn text-uppercase mb-3"
          (click)="newEnergyProviderRates()"
        >
          see new rates
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Modal -->
<div class="backdrop" [ngStyle]="{ display: display }"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ display: display }">
  <div class="modal-dialog" role="document">
    <div class="modal-content m-auto blockbg boxclr text-center">
      <div class="modal-body">
        <!-- <div class="mt-5"> -->
        <div class="">
          <img src="assets/images/loading.gif" />
          <p class="text-center tipmes font15">
            Please wait a few seconds while we process your enrollment.
          </p>
        </div>
        <!-- </div> -->
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
<!-- /.modal !-->
<!--Custom Modal for Deposit Required Screen-->
<ng-template #depositPending>
  <div id="serviceunavialbe">
    <div class="modal-header pr-1 pt-1">
      <div class="col-12 text-right py-0 px-0">
        <button
          type="button"
          class="close pull-right borderNone closeModelAlign"
          aria-label="Close"
          (click)="closeDepositPendingModal()"
        >
          <div _ngcontent-c5="" class="float-right mr-1 mt-1">
            <img src="assets/images/editchart-close.svg" width="17" />
          </div>
        </button>
      </div>
    </div>
    <div class="modal-body pt-0 webview">
      <h4 class="utility-modal-title font20 text-center text-uppercase">
        A DEPOSIT IS REQUIRED TO SIGNUP
      </h4>
      <p class="utility-sub-title font20">
        Due to your credit, a {{ securityDeposit }} security deposit is
        required. To not miss out on this offer and get your service request
        processed today, please click the button below.
      </p>
      <br />
      <p class="utility-sub-title font20">
        <strong
          style="font-size: 19px !important; font-family: 'Calibre-SemiBold'"
          >Important Note:</strong
        >
        If you choose to pay the deposit, it will be returned to you with
        interest either after one year as a customer-in-good-standing with
        {{ selectedProduct.energy_provider }}, or if you move-out of your
        location before your contract expires. Please see your Terms of Service
        for {{ selectedProduct.energy_provider }}’s Deposit Policy.
      </p>
      <br />
      <p class="utility-sub-title font20" *ngIf="displayInvoiceValueBoth()">
        This deposit requirement may be waived if you call
        {{ selectedProduct.energy_provider }} and provide a letter of credit
        from your most recent REP, proof that you’re a victim of family
        violence, or proof that you are 65 years of age or older in good
        standing. You must call {{ selectedProduct.energy_provider }} at
        {{ selectedProduct.providerContact }}.
      </p>
      <br />
      <div class="col-12 text-center webview">
        <label
          class="custom-control custom-checkbox chkbox mb-2"
          for="payfordeposit"
          id="selectDeposit"
          style="
            box-shadow: 0 1px 1px rgb(0 0 0 / 8%) inset,
              0 3px 6px 0 rgb(180 180 180 / 80%) !important;
          "
        >
          <input
            type="checkbox"
            class="custom-control-input mgntp10"
            id="payfordeposit"
            value="{{ securityDepositText }}"
            name="payfordeposit"
            (click)="openDepositPendingModal()"
          />
          <label style="text-align:left"
            class="custom-control-label font16 ml-2 customLabel"
            for="payfordeposit"
            >{{ securityDepositText }}</label
          >
        </label>
        <label
          class="custom-control custom-checkbox chkbox mb-2 box-shadow"
          for="anotherEnergyProvider"
        >
          <input
            type="checkbox"
            class="custom-control-input mgntp10"
            id="anotherEnergyProvider"
            value="Applyforadepositwaiver"
            name="anotherEnergyProvider"
            (click)="selectNewProvider()"
          />
          <label style="text-align:left"
            class="custom-control-label font16 ml-2 customLabel"
            for="anotherEnergyProvider"
            >Get started with prepaid electricity 
            for just $50. No deposit required</label
          >
        </label>
      </div>
    </div>
    <div class="modal-body pt-0 mobileview">
      <h4 class="utility-modal-title font20 text-center text-uppercase">
        A DEPOSIT IS REQUIRED TO SIGNUP
      </h4>
      <p class="utility-sub-title font16">
        Due to your credit, a {{ securityDeposit }} security deposit is
        required. To not miss out on this offer and get your service request
        processed today, please click the button below.
      </p>
      <br />
      <p class="utility-sub-title font16">
        <strong
          style="font-size: 19px !important; font-family: 'Calibre-SemiBold'"
          >Important Note:</strong
        >
        If you choose to pay the deposit, it will be returned to you with
        interest either after one year as a customer-in-good-standing with
        {{ selectedProduct.energy_provider }}, or if you move-out of your
        location before your contract expires. Please see your Terms of Service
        for {{ selectedProduct.energy_provider }}’s Deposit Policy.
      </p>
      <br />
      <div *ngIf="displayInvoiceValueBoth()">
        <p class="utility-sub-title font16">
          This deposit requirement may be waived if you call
          {{ selectedProduct.energy_provider }} and provide a letter of credit
          from your most recent REP, proof that you’re a victim of family
          violence, or proof that you are 65 years of age or older in good
          standing. You must call {{ selectedProduct.energy_provider }} at
          {{ selectedProduct.providerContact }}.
        </p>
        <br />
      </div>
      <div class="col-12 text-center">
        <label
          class="custom-control custom-checkbox chkbox mb-2"
          for="payfordeposit"
          id="selectDeposit"
          style="
            box-shadow: 0 1px 1px rgb(0 0 0 / 8%) inset,
              0 3px 6px 0 rgb(180 180 180 / 80%) !important;
          "
        >
          <input
            type="checkbox"
            class="custom-control-input mgntp10"
            id="payfordeposit"
            value="{{ securityDepositText }}"
            name="payfordeposit"
            [checked]="payDepositChecked"
            (click)="openDepositPendingModal()"
          />
          <label style="text-align:left"
            class="custom-control-label font16 ml-2 customLabel"
            for="payfordeposit"
            >{{ securityDepositText }}</label
          >
        </label>
        <label
          class="custom-control custom-checkbox chkbox mb-2"
          for="anotherEnergyProvider"
          id="anotherProvider"
          style="
            box-shadow: 0 1px 1px rgb(0 0 0 / 8%) inset,
              0 3px 6px 0 rgb(180 180 180 / 80%) !important;
          "
        >
          <input
            type="checkbox"
            class="custom-control-input mgntp10"
            id="anotherEnergyProvider"
            value="Applyforadepositwaiver"
            name="anotherEnergyProvider"
            [checked]="closeDeposit"
            (click)="selectNewProvider()"
          />
          <label style="text-align:left"
            class="custom-control-label font16 ml-2 customLabel"
            for="anotherEnergyProvider"
            >Get started with prepaid electricity 
            for just $19.99. No deposit required</label
          >
        </label>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #errorStatus4CE>
  <!-- <div id="serviceunavialbe">
    <div class="modal-header pr-1 pt-1">
      <div class="col-12 text-right py-0 px-0">
        <button
          type="button"
          class="close pull-right borderNone closeModelAlign"
          aria-label="Close"
          (click)="newEnergyProviderRates()"
        >
          <div _ngcontent-c5="" class="float-right mr-1 mt-1">
            <img
              src="assets/images/editchart-close.svg"
              width="17"
              style="margin-top: -10px"
            />
          </div>
        </button>
      </div>
    </div>
    <div class="modal-body pt-0">
      <p class="utility-sub-title font20">
        Please be sure to mention ‘Honest Gorilla’ when speaking with a representative for faster service.
      </p>
      <br />
      <h4 class="utility-modal-title font20 text-center text-uppercase">
        Uh-oh! An Error Has Occurred
      </h4>
      <p class="utility-sub-title font20">
        While processing your information, it seems that something did not go as
        planned.
      </p>
      <br />
      <p class="utility-sub-title font20">
        To save the headache of trying to figure it out, it will be quickest for
        you to call {{ selectedProduct.energy_provider }} and speak to one of
        their customer care specialists.
      </p>
      <br />
      <p class="utility-sub-title font20">
        Click or call
        <a
          [href]="customerEnrollmentHotlineLink()"
          style="color: blue !important"
        >
          {{ customerEnrollmentHotline() }}</a
        >
        for immediate assistance and to finish signing up. We apologize for the
        inconvenience.
      </p>
      <br />
      <p class="utility-sub-title font20">
        Please be sure to mention ‘Honest Gorilla’ when speaking with a representative for faster service.
      </p>

      <div class="col-12 text-center">
        <button
          id="enrollment-payment-form-submit-button"
          class="btn sectbtn my-2 text-uppercase"
          style="
            width: auto !important;
            padding-left: 25px;
            font-size: 18px !important;
            padding-right: 25px;
          "
          (click)="newEnergyProviderRates()"
        >
          Thank You
        </button>
        
      </div>
      <br>
        <div *ngIf="ShowAPIErrorMsg"  class="alert alert-danger" ><div style="cursor: pointer;" (click)="redirectto3rdStep(APIErrorMsg)">API Response: <div [innerHTML]="APIErrorMsg"></div></div></div>
    </div>
  </div> -->

<div  [ngClass]="{ 'force-mobile': isMobileView }" class="hg-modal is-open" role="dialog" aria-labelledby="hg-sh-title" aria-modal="true" id="switchHoldModal">
  <div class="hg-modal__overlay" tabindex="-1"></div>

  <div class="hg-modal__panel" role="document">
    <button class="hg-modal__close" aria-label="Close popup" (click)="newEnergyProviderRates()">&times;</button>

    <div class="hg-modal__header">
      <div class="hg-modal__icon" aria-hidden="true">
        <!-- Adjusted SVG with padded viewBox and slightly smaller size -->
        <svg viewBox="-2 -2 28 28" width="19" height="19" fill="currentColor" style="overflow:visible">
          <path d="M12 0L0 14h8v10l14-16h-8l2-8z"/>
        </svg>
      </div>
      <h2 id="hg-sh-title" class="hg-modal__title" style="font-family: var(--hg-font);">Your enrollment is almost complete.</h2>
    </div>

    <p class="hg-modal__text">
      
    
      {{ selectedProduct.energy_provider }} just needs one quick confirmation to finalize your setup.
     
    </p>

      <p class="hg-modal__text">
      
    
      To finish your signup right away, call <a class="hg-link" target="_top" [href]="customerEnrollmentHotlineLink()"  rel="noopener">{{ customerEnrollmentHotline() }}</a> and let the representative know you’re signing up through Honest Gorilla - they’ll pull up your details immediately.
      
    </p>

     <p class="hg-modal__text">
      
    
     
      Thanks for taking this last step - you’re just about done!
    </p>

    
    <div *ngIf="ShowAPIErrorMsg"  class="alert alert-danger" ><div style="cursor: pointer;" (click)="redirectto3rdStep(APIErrorMsg)">API Response: <div [innerHTML]="APIErrorMsg"></div></div></div>

    <div class="hg-modal__actions">
      <a class="hg-btn hg-btn--primary no-underline" target="_top" [href]="customerEnrollmentHotlineLink()">
        Call {{ customerEnrollmentHotline() }}
      </a>
      <button class="hg-btn hg-btn--ghost" aria-label="Close" (click)="newEnergyProviderRates()">Got it</button>
    </div>
  </div>
</div>

</ng-template>
